<template>
  <div class="row">
    <modal :show.sync="modals.submit" class="modal-eprf" centered>
      <div class="row">
        <div class="col-lg text-center">
          <img src="@/assets/img/tick.png" width="300" />
          <br />
          <br />
          <br />
          <h1>JOB REQUEST SUCCESSFULLY SUBMITTED</h1>
          <p>
            Our Customer Relations Officer will be in touch with you within 24
            hours
          </p>
        </div>
      </div>
    </modal>

    <modal :show.sync="modals.warningsubmit" class="modal-eprf" centered>
      <div class="row">
        <div class="col-lg text-center">
          Please fill in all the required data.
        </div>
      </div>
    </modal>
    <modal :show.sync="modals.supportdoc" class="modal-eprf" centered>
      <b-card
        class="card text-center"
        style="background-color: #f5f6fa; box-shadow: none"
        border-variant="primary"
        header="DOCUMENTS"
        header-bg-variant="primary"
        header-text-variant="white"
      >
        <template #header>
          <div class="row">
            <div class="col-lg text-left">
              <h4 class="mb-0">DOCUMENTS</h4>
            </div>
            <div class="col-lg-3 text-right" style="padding-bottom: 10px">
              <base-button class="btn-icon btn-cancel btn-round btn-sm">
                <i
                  style="
                    transform: translate(-50%, -50%);
                    color: white;
                    font-weight: 900;
                    font-size: 12px;
                  "
                  class="tim-icons icon-simple-remove"
                  @click="modals.supportdoc = false"
                ></i>
              </base-button>
            </div>
          </div>
        </template>

        <div
          :style="{
            height: msdsopen ? '400px' : '180px',
            overflow: 'auto',
            'overflow-x': 'hidden',
          }"
        >
          <div class="col-lg-12">
            <el-table
              :data="allmaterialname"
              :header-cell-style="{
                background: '#358DCC',
                border: 'transparent',
                'font-size': '14px',
                'font-weight': '400',
                color: '#FFFFFF',
              }"
            >
              <el-table-column width="100" label="" align="center">
                <template slot="header" slot-scope="scope">
                  <div @click="openmsds()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div v-if="msdsopen == true" slot-scope="scope">
                  <p style="font-size: 14px; color: #707070">
                    {{ scope.$index + 1 }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column
                label="Manifold Plan / Diagram"
                :min-width="350"
                prop="filename"
                align="center"
              >
                <template slot="header" slot-scope="scope">
                  <div @click="openmsds()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div
                  v-if="msdsopen == true"
                  slot-scope="scope"
                  style="height: 20px"
                  align="left"
                >
                  <p style="font-size: 14px; color: #707070">
                    {{ scope.row.filename }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column label="▼" width="100" align="center">
                <template slot="header" slot-scope="scope">
                  <div @click="openmsds()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div v-if="msdsopen == true" slot-scope="scope">
                  <p style="font-size: 14px; color: #707070">
                    <a :href="scope.row.fileurl" target="_blank">
                      <i class="tim-icons icon-cloud-download-93 download-icon"></i>

                    </a>
                  </p>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div
          :style="{
            height: stowageopen ? '400px' : '180px',
            overflow: 'auto',
            'overflow-x': 'hidden',
          }"
        >
          <div class="col-lg-12">
            <el-table
              :data="allstowagename"
              :header-cell-style="{
                background: '#358DCC',
                border: 'transparent',
                'font-size': '14px',
                'font-weight': '400',
                color: '#FFFFFF',
              }"
            >
              <el-table-column width="100" align="center">
                <template slot="header" slot-scope="scope">
                  <div @click="openstowage()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div v-if="stowageopen == true" slot-scope="scope">
                  <p style="font-size: 14px; color: #707070">
                    {{ scope.$index + 1 }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column
                label="Stowage Plan"
                :min-width="350"
                prop="filename"
                align="center"
              >
                <template slot="header" slot-scope="scope">
                  <div @click="openstowage()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div
                  v-if="stowageopen == true"
                  slot-scope="scope"
                  style="height: 20px"
                  align="left"
                >
                  <p style="font-size: 14px; color: #707070">
                    {{ scope.row.filename }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column label="▼" width="100" align="center">
                <template slot="header" slot-scope="scope">
                  <div @click="openstowage()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div v-if="stowageopen == true" slot-scope="scope">
                  <p style="font-size: 14px; color: #707070">
                    <a :href="scope.row.fileurl" target="_blank">
                      <i class="tim-icons icon-cloud-download-93 download-icon"></i>

                    </a>
                  </p>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div
          :style="{
            height: otheropen ? '400px' : '180px',
            overflow: 'auto',
            'overflow-x': 'hidden',
          }"
        >
          <div class="col-lg-12">
            <el-table
              :data="allfilename"
              :header-cell-style="{
                background: '#358DCC',
                border: 'transparent',
                'font-size': '14px',
                'font-weight': '400',
                color: '#FFFFFF',
              }"
            >
              <el-table-column width="100" align="center">
                <template slot="header" slot-scope="scope">
                  <div @click="openother()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div v-if="otheropen == true" slot-scope="scope">
                  <p style="font-size: 14px; color: #707070">
                    {{ scope.$index + 1 }}
                  </p>
                </div>
              </el-table-column>

              <el-table-column
                label="Job Supporting Documents"
                :min-width="350"
                prop="filename"
                align="center"
              >
                <template slot="header" slot-scope="scope">
                  <div @click="openother()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div
                  v-if="otheropen == true"
                  slot-scope="scope"
                  style="height: 20px"
                  align="left"
                >
                  <p style="font-size: 14px; color: #707070">
                    {{ scope.row.filename }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column label="▼" width="100" align="center">
                <template slot="header" slot-scope="scope">
                  <div @click="openother()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div v-if="otheropen == true" slot-scope="scope">
                  <a :href="scope.row.fileurl" target="_blank">
                    <i class="tim-icons icon-cloud-download-93 download-icon"></i>

                  </a>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div
          :style="{
            height: quoopen ? '400px' : '180px',
            overflow: 'auto',
            'overflow-x': 'hidden',
          }"
        >
          <div class="col-lg-12">
            <el-table
              :data="allquodocname"
              :header-cell-style="{
                background: '#358DCC',
                border: 'transparent',
                'font-size': '14px',
                'font-weight': '400',
                color: '#FFFFFF',
              }"
            >
              <el-table-column width="100" align="center">
                <template slot="header" slot-scope="scope">
                  <div @click="openquo()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div v-if="quoopen == true" slot-scope="scope">
                  <p style="font-size: 14px; color: #707070">
                    {{ scope.$index + 1 }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column
                label="Quotation Supporting Documents"
                :min-width="350"
                prop="filename"
                align="center"
              >
                <template slot="header" slot-scope="scope">
                  <div @click="openquo()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div
                  v-if="quoopen == true"
                  slot-scope="scope"
                  style="height: 20px"
                  align="left"
                >
                  <p style="font-size: 14px; color: #707070">
                    {{ scope.row.filename }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column label="▼" width="100" align="center">
                <template slot="header" slot-scope="scope">
                  <div @click="openquo()" style="cursor: pointer">
                    <span>{{ scope.column.label }}</span>
                  </div>
                </template>
                <div v-if="quoopen == true" slot-scope="scope">
                  <a :href="scope.row.fileurl" target="_blank">
                    <i class="tim-icons icon-cloud-download-93 download-icon"></i>

                  </a>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </b-card>
    </modal>
    <modal :show.sync="modals.failedModal" :preventClose="true">
      <div
        style="
          margin: -24px -24px 0px -24px;
          padding: 20px 40px 20px 40px;
          background-color: #EC1B23;
          text-align: center;
        "
      >
        <div class="row">
          <div class="col-lg"></div>
          <div class="col-lg-6 text-center">
            <div
              style="
                text-align: center;
                border-radius: 100%;
                border: 10px solid white;
              "
            >
              <i
                style="
                  padding: 15px;
                  color: white;
                  font-size: 130px;
                  font-weight: 900;
                "
                class="fa fa-exclamation"
              ></i>
            </div>
            <div>
              <p
                style="
                  color: white;
                  font-size: 17px;
                  text-align: center;
                  font-weight: 500;
                "
              >
                Error
              </p>
            </div>
          </div>
          <div class="col-lg"></div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-lg-12 text-center">
          <p style="color: #A5A5A5">{{ message }}</p>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-lg-12 text-center" style="margin-bottom: 50px">
          <p style="color: #A5A5A5; margin-top: 20px">Click 'Retry' to go back.</p>

          <base-button type="danger" v-on:click="modals.failedModal"
            >Exit</base-button
          >&nbsp;
          <base-button type="primary" v-on:click="modals.failedModal = false"
            >Retry</base-button
          >
        </div>
      </div>
    </modal>
    <StatusModal
      :show.sync="modals.removeModal"
      :message="modal.remove"
      :title="modal.removeTitle"
    />
    <StatusModal
      :show.sync="modals.successModal"
      :message="modal.success"
      :title="modal.successTitle"
    />

    <!-- <modal :show.sync="modals.msdsdoc" class="modal-eprf" centered>
      <b-card class="card text-center" style="background-color: #f5f6fa; box-shadow: none" border-variant="primary"
        header="MANIFOLD PLAN/DIAGRAM" header-bg-variant="primary" header-text-variant="white">
        <template #header>
          <div class="row">
            <div class="col-lg text-left">
              <h4 class="mb-0">MANIFOLD PLAN/DIAGRAM</h4>
            </div>
            <div class="col-lg-3 text-right" style="padding-bottom: 10px">
              <base-button class="btn-icon btn-cancel btn-round btn-sm">
                <i style="
                      transform: translate(-50%, -50%);
                      color: white;
                      font-weight: 900;
                      font-size: 12px;
                    " class="tim-icons icon-simple-remove" @click="modals.msdsdoc = false"></i>
              </base-button>
            </div>
          </div>
        </template>

        <div style="height: 400px; overflow: scroll; overflow-x: hidden">
          <div class="col-lg-12">
            <el-table :data="allmaterialname" :header-cell-style="{
      background: '#358DCC',
      border: 'transparent',
      'font-size': '14px',
      'font-weight': '400',
      color: '#FFFFFF',
    }">
              <el-table-column label="No." width="50" align="center">
                <div slot-scope="scope">
                  <p style="font-size: 14px;color: #707070">
                    {{ scope.$index + 1 }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column label="Document name" :min-width="350" prop="filename" align="center">
                <div slot-scope="scope" align="left">
                  <p style="font-size: 14px;color: #707070">
                    {{ scope.row.filename }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column label="" width="150" align="center">
                <div slot-scope="scope">
                  <p style="font-size: 14px; color: #707070">
                    <a :href="scope.row.fileurl" target="_blank">
                      <i style="color: #A5A5A5; font-size: 18px; font-weight: 900"
                        class="tim-icons icon-cloud-download-93"></i>
                    </a>
                  </p>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </b-card>
    </modal>

    <modal :show.sync="modals.stowagedoc" class="modal-eprf" centered>
      <b-card class="card text-center" style="background-color: #f5f6fa; box-shadow: none" border-variant="primary"
        header="STOWAGE PLAN" header-bg-variant="primary" header-text-variant="white">
        <template #header>
          <div class="row">
            <div class="col-lg text-left">
              <h4 class="mb-0">STOWAGE PLAN</h4>
            </div>
            <div class="col-lg-3 text-right" style="padding-bottom: 10px">
              <base-button class="btn-icon btn-cancel btn-round btn-sm">
                <i style="
                      transform: translate(-50%, -50%);
                      color: white;
                      font-weight: 900;
                      font-size: 12px;
                    " class="tim-icons icon-simple-remove" @click="modals.stowagedoc = false"></i>
              </base-button>
            </div>
          </div>
        </template>

        <div style="height: 400px; overflow: scroll; overflow-x: hidden">
          <div class="col-lg-12">
            <el-table :data="allstowagename" :header-cell-style="{
      background: '#358DCC',
      border: 'transparent',
      'font-size': '14px',
      'font-weight': '400',
      color: '#FFFFFF',
    }">
              <el-table-column label="No." width="50" align="center">
                <div slot-scope="scope">
                  <p style="font-size: 14px;color: #707070">
                    {{ scope.$index + 1 }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column label="Document name" :min-width="350" prop="filename" align="center">
                <div slot-scope="scope" align="left">
                  <p style="font-size: 14px;color: #707070">
                    {{ scope.row.filename }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column label="" width="150" align="center">
                <div slot-scope="scope">
                  <p style="font-size: 14px; color: #707070">
                    <a :href="scope.row.fileurl" target="_blank">
                      <i style="color: #A5A5A5; font-size: 18px; font-weight: 900"
                        class="tim-icons icon-cloud-download-93"></i>
                    </a>
                  </p>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </b-card>
    </modal> -->

    <!-- <modal :show.sync="modals.supportdoc" class="modal-eprf" centered>
      <b-card class="card text-center" style="background-color: #f5f6fa; box-shadow: none" border-variant="primary"
        header="JOB SUPPORTING DOCUMENTS" header-bg-variant="primary" header-text-variant="white">
        <template #header>
          <div class="row">
            <div class="col-lg text-left">
              <h4 class="mb-0">JOB SUPPORTING DOCUMENTS</h4>
            </div>
            <div class="col-lg-3 text-right" style="padding-bottom: 10px">
              <base-button class="btn-icon btn-cancel btn-round btn-sm">
                <i style="
                      transform: translate(-50%, -50%);
                      color: white;
                      font-weight: 900;
                      font-size: 12px;
                    " class="tim-icons icon-simple-remove" @click="modals.supportdoc = false"></i>
              </base-button>
            </div>
          </div>
        </template>

        <div style="height: 400px; overflow: scroll; overflow-x: hidden">
          <div class="col-lg-12">
            <el-table :data="allfilename" :header-cell-style="{
      background: '#358DCC',
      border: 'transparent',
      'font-size': '14px',
      'font-weight': '400',
      color: '#FFFFFF',
    }">
              <el-table-column label="No." width="50" align="center">
                <div slot-scope="scope">
                  <p style="font-size: 14px;color: #707070">
                    {{ scope.$index + 1 }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column label="Document name" :min-width="350" prop="filename" align="center">
                <div slot-scope="scope" align="left">
                  <p style="font-size: 14px;color: #707070">
                    {{ scope.row.filename }}
                  </p>
                </div>
              </el-table-column>
              <el-table-column label="" width="150" align="center">
                <div slot-scope="scope">
                  <p style="font-size: 14px; color: #707070">
                    <a :href="scope.row.fileurl" target="_blank">
                      <i style="color: #A5A5A5; font-size: 18px; font-weight: 900"
                        class="tim-icons icon-cloud-download-93"></i>
                    </a>
                  </p>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </b-card>
    </modal> -->

    <div class="col-lg">
      <div v-if="submitted == 'add'">
        <div v-if="submit == false" class="row">
          <div class="col-lg-4">
            <card class="card-eprf">
              <div
                class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto"
              >
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  JOB DETAILS
                </p>

                <p class="new-title">Job Reference No.</p>
                <p class="subtitle">{{ this.jobno }}</p>

                <p class="new-title">
                  Arrival ETA <span style="color: #EC1B23">*</span>
                </p>
                <el-date-picker
                  v-model="arrival"
                  placeholder="Select time"
                  :picker-options="arrivalOptions"
                  @change="checkArrival"
                ></el-date-picker>
                <!--{{ this.arrival }}-->

                <p class="new-title">
                  Departure (ETD) <span style="color: #EC1B23">*</span>
                </p>
                <el-date-picker
                  v-model="departure"
                  placeholder="Select time"
                  :picker-options="departureOptions"
                  @change="getData()"
                ></el-date-picker>
                <!-- {{ this.departure }} -->

                <p class="new-title">
                  Previous Port <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input
                    type="text"
                    v-model="previousport"
                    :class="{ 'custom-input': true }"
                  />
                </div>

                <p class="new-title">
                  Next Port <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input
                    type="text"
                    v-model="nextport"
                    :class="{ 'custom-input': true }"
                  />
                </div>

                <p class="new-title">
                  Last Port When Generated Waste Delivered
                  <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input
                    type="text"
                    v-model="lastport"
                    :class="{ 'custom-input': true }"
                  />
                </div>

                <p class="new-title">
                  Date When Generated Waste Delivered
                  <span style="color: #EC1B23">*</span>
                </p>
                <el-date-picker
                  v-model="lastportdate"
                  placeholder="Select date"
                  :picker-options="arrivalOptions"
                ></el-date-picker>

                <p class="new-title">Ships <span style="color: #EC1B23">*</span></p>
                <el-select
                  class="select-info tab select-width"
                  popper-class="custom-dropdown"
                  placeholder="Select"
                  v-model="selects.ship"
                  style="width: 90%; border-bottom: 1px solid lightgray"
                  @change="getType()"
                  filterable
                >
                  <el-option
                    v-for="option in selects.ships"
                    class="select-info custom-option"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>

                <p class="new-title">
                  Service Location <span style="color: #EC1B23">*</span>
                </p>
                <el-select
                  class="select-info tab select-width"
                  popper-class="custom-dropdown"
                  placeholder="Select"
                  v-model="selects.location"
                  style="width: 90%; border-bottom: 1px solid lightgray"
                  @change="getType()"
                  filterable
                >
                  <el-option
                    v-for="option in selects.locations"
                    class="select-info custom-option"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>

                <p class="new-title">
                  Service Location Collection <span style="color: #EC1B23">*</span>
                </p>
                <el-select
                  class="select-info tab select-width"
                  popper-class="custom-dropdown"
                  placeholder="Select"
                  v-model="selects.collection"
                  style="width: 90%; border-bottom: 1px solid lightgray"
                  filterable
                >
                  <el-option
                    v-for="option in selects.collections"
                    class="select-info custom-option"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>

                <p class="new-title">
                  PIC Full Name <span style="color: #EC1B23">*</span>
                </p>
                <el-select
                  class="select-info tab select-width"
                  popper-class="custom-dropdown"
                  placeholder="Select"
                  v-model="selects.pic"
                  style="width: 90%; border-bottom: 1px solid lightgray"
                  @change="getType()"
                  filterable
                >
                  <el-option
                    v-for="option in selects.pics"
                    class="select-info custom-option"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>

                <p class="new-title">PIC Phone No.</p>
                <p class="subtitle">{{ phoneno }}</p>

                <p class="new-title">PIC Fax No.</p>
                <p class="subtitle">{{ faxno }}</p>

                <p class="new-title">PIC Email</p>
                <p class="subtitle">{{ email }}</p>
              </div>
            </card>
          </div>
          <div class="col-lg-8">
            <card
              style="
                box-shadow: none;
                padding: 0px 0px 30px 30px;
                height: 630px;
                color: #A5A5A5;
                background-color: white;
              "
            >
              <!-- <div class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto"> -->
              <div class="row" style="display: flex">
                <div class="col-lg">
                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                    WASTE DETAILS
                  </p>
                </div>
              </div>
              <div
                id="tableku"
                v-if="this.load == false"
                style="height: 500px; overflow: auto; overflow-x: hidden"
              >
                <div class="row">
                  <div class="col-lg">
                    <el-table
                      :data="tableDatas"
                      :header-cell-style="{
                        background: '#358DCC',
                        border: 'transparent',
                        'font-size': '14px',
                        'font-weight': '400',
                        color: '#FFFFFF',
                        'word-wrap': 'break-word',
                      }"
                      :cell-style="{ fontColor: '#707070' }"
                      :row-style="tableRowClassName"
                      style="color: #707070"
                    >
                      <el-table-column label="NO." width="50" align="center">
                        <div slot-scope="scope">
                          <p style="color: #707070">
                            {{ scope.$index + 1 }}
                          </p>
                        </div>
                      </el-table-column>
                      <el-table-column
                        :min-width="300"
                        align="center"
                        prop="wastetype"
                        label="WASTE TYPE"
                      >
                        <div slot-scope="scope">
                          <div align="center">
                            <div class="row">
                              <div style="position: relative">
                                <span
                                  style="
                                    color: #EC1B23;
                                    position: absolute;
                                    bottom: 17%;
                                    right: 0;
                                  "
                                  >*</span
                                >
                                <el-select
                                  class="select-info tab select-width"
                                  placeholder="Select waste type"
                                  popper-class="custom-dropdown"
                                  v-model="scope.row.wastetype"
                                  style="width: 100%"
                                  filterable
                                >
                                  <el-option
                                    v-for="option in selects.wastetypes"
                                    class="select-info custom-option"
                                    :value="option.value"
                                    :label="option.label"
                                    :key="option.value"
                                  ></el-option>
                                </el-select>
                              </div>
                            </div>

                            <div class="row">
                              <div style="position: relative">
                                <span
                                  style="
                                    color: #EC1B23;
                                    position: absolute;
                                    bottom: 17%;
                                    right: 0;
                                  "
                                  >*</span
                                >
                                <el-select
                                  class="select-info tab select-width"
                                  popper-class="custom-dropdown"
                                  placeholder="Sub-waste Type"
                                  v-model="scope.row.swcode"
                                  style="width: 100%"
                                  @change="
                                    getTypee(
                                      // scope.$index,
                                      selectedfirst,
                                      scope.row.swcode,
                                      scope.row
                                    )
                                  "
                                  filterable
                                >
                                  <el-option
                                    v-for="option in scope.row.wastesubtypes"
                                    class="select-info custom-option"
                                    :value="option.value"
                                    :label="option.label"
                                    :key="option.value"
                                    style="
                                      width: 300px;
                                      height: auto;
                                      white-space: normal;
                                    "
                                  >
                                  </el-option>
                                </el-select>
                              </div>
                            </div>

                            <div
                              v-if="scope.row.check == true"
                              style="width: 100%"
                              align="left"
                            >
                              <input
                                type="text"
                                v-model="scope.row.specifywastetype"
                                :class="{ 'custom-input': true }"
                                @focus="handleFocus(scope.row)"
                                
                              />
                              <!-- @input="handleInput(scope.row.specifywastetype)" -->
                              <p
                                v-if="scope.row.buttonadd === true"
                                @click="
                                  handleSpecify(
                                    scope.row.specifywastetype,
                                    scope.row
                                  )
                                "
                                style="
                                  text-align: right;
                                  color: #358CCB;
                                  cursor: pointer;
                                "
                                class="link"
                              >
                                + Add new sub waste typee
                                <span style="color: #EC1B23">*</span>
                              </p>
                            </div>

                            <!-- <div v-if="scope.row.wastetype == '6'" style="width: 80%" align="left">
                            <span style="color: #EC1B23;">*</span>
                            <input type="text" v-model="scope.row.specifywastetype" :class="{ 'custom-input': true }"
                              @focus="handleFocus(scope.row)" @input="handleInput(scope.row.specifywastetype)" />
                            <p v-if="scope.row.buttonadd === true" @click="
        handleSpecify(
          scope.row.specifywastetype,
          scope.row
        )
        " style="
                                text-align: right;
                                color: #358CCB;
                                cursor: pointer;
                              " class="link">
                              + Add new sub waste type
                            </p>
                          </div> -->

                            <!-- <div v-if="(scope.row.wastetype == '8' &&
        scope.row.swcode == '26') ||
        (scope.row.wastetype == '8' &&
          scope.row.swcode == '27')
        " style="width: 80%" align="left">
                            <span style="color: #EC1B23;">*</span>
                            <input type="text" v-model="scope.row.specifywastetype" :class="{ 'custom-input': true }"
                              @focus="handleFocus(scope.row)" @input="handleInput(scope.row.specifywastetype)" />
                            <p v-if="scope.row.buttonadd === true" @click="
        handleSpecify(
          scope.row.specifywastetype,
          scope.row
        )
        " style="
                                text-align: right;
                                color: #358CCB;
                                cursor: pointer;
                              " class="link">
                              + Add new sub waste type
                            </p>
                          </div> -->
                          </div>
                        </div>
                      </el-table-column>
                      <el-table-column
                        :min-width="250"
                        align="center"
                        prop="wasteqty"
                        label="WASTE QTY."
                      >
                        <div slot-scope="{ row }">
                          <div align="center">
                            <div class="row">
                              <div class="col-lg-8">
                                <div style="width: 100%" align="left">
                                  <input
                                    type="number"
                                    v-model="row.estqty"
                                    :min="0"
                                    :class="{ 'custom-input': true }"
                                  />
                                </div>
                              </div>
                              <div class="col-lg">
                                <p class="new-title">
                                  <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="is metric cubic"
                                    placement="top-start"
                                  >
                                    <p class="new-title">
                                      CBM<span style="color: #EC1B23">*</span>
                                    </p>
                                  </el-tooltip>
                                </p>
                              </div>
                            </div>
                            <!-- <div class="row">
                            <div class="col-lg text-left">
                              <span style="color: #EC1B23;">*</span>
                              <el-select class="select-info tab select-width" placeholder="Select waste unit"
                                v-model="row.measurement" style="width: 100%" @change="getType()" filterable>
                                <el-option v-for="option in selects.measurements" class="select-info custom-option"
                                  :value="option.value" :label="option.label" :key="option.value"></el-option>
                              </el-select>

                            </div>
                          </div> -->
                          </div>
                        </div>
                      </el-table-column>
                      <el-table-column
                        :min-width="260"
                        align="center"
                        prop="storage"
                        label="MAX DEDICATED STORAGE CAPACITY"
                      >
                        <div slot-scope="{ row }">
                          <div align="center">
                            <div class="row">
                              <div class="col-lg-8">
                                <div style="width: 100%" align="left">
                                  <!-- <span style="color: #EC1B23;">*</span> -->
                                  <input
                                    type="number"
                                    v-model="row.storage"
                                    :min="0"
                                    :class="{ 'custom-input': true }"
                                  />
                                </div>
                              </div>
                              <div class="col-lg">
                                <p class="new-title">
                                  <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="is metric cubic"
                                    placement="top-start"
                                  >
                                    <p class="new-title">
                                      CBM<span style="color: #EC1B23">*</span>
                                    </p>
                                  </el-tooltip>
                                </p>
                              </div>

                              <!-- </div> -->
                            </div>
                            <!-- <div class="row">
                            <div class="col-lg text-left">
                              <span style="color: #EC1B23;">*</span>
                              <el-select class="select-info tab select-width" placeholder="Select waste unit"
                                v-model="row.measurement1" style="width: 100%" @change="getType()" filterable>
                                <el-option v-for="option in selects.measurement1s" class="select-info custom-option"
                                  :value="option.value" :label="option.label" :key="option.value"></el-option>
                              </el-select>

                            </div>
                          </div> -->
                          </div>
                        </div>
                      </el-table-column>
                      <el-table-column
                        :min-width="250"
                        align="center"
                        prop="retain"
                        label="WASTE AMOUNT RETAINED ON-BOARD"
                      >
                        <div slot-scope="{ row }">
                          <div align="center">
                            <div class="row">
                              <div class="col-lg-8">
                                <div style="width: 100%" align="left">
                                  <input
                                    type="number"
                                    :min="0"
                                    v-model="row.retain"
                                    :class="{ 'custom-input': true }"
                                  />
                                </div>
                              </div>
                              <div class="col-lg">
                                <p class="new-title">
                                  <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="is metric cubic"
                                    placement="top-start"
                                  >
                                    <p class="new-title">
                                      CBM<span style="color: #EC1B23">*</span>
                                    </p>
                                  </el-tooltip>
                                </p>
                              </div>
                            </div>
                            <!-- <div class="row">
                            <div class="col-lg text-left">
                              <span style="color: #EC1B23;">*</span>
                              <el-select class="select-info tab select-width" placeholder="Select waste unit"
                                v-model="row.measurement2" style="width: 100%" @change="getType()" filterable>
                                <el-option v-for="option in selects.measurement2s" class="select-info custom-option"
                                  :value="option.value" :label="option.label" :key="option.value"></el-option>
                              </el-select>
                            </div>
                          </div> -->
                          </div>
                        </div>
                      </el-table-column>
                      <el-table-column
                        :min-width="200"
                        align="center"
                        prop="remarks"
                        label="REMARKS"
                      >
                        <div slot-scope="{ row }">
                          <input
                            type="text"
                            v-model="row.remarks"
                            :class="{ 'custom-input': true }"
                          />
                          <!-- <textarea
                  type="textarea"
                  placeholder="Remarks..."
                  v-model="remarks"
                  :class="{ 'custom-input-2': true }"
                ></textarea> -->
                        </div>
                      </el-table-column>
                      <el-table-column
                        width="50"
                        align="center"
                        prop="delete"
                        label=""
                      >
                        <div slot-scope="scope">
                          <i
                            v-if="scope.$index != 0"
                            style="
                              position: absolute;
                              top: 50%;
                              left: 50%;
                              transform: translate(-50%, -50%);
                              color: #ff0000;
                              font-size: 15px;
                              font-weight: 900;
                              cursor: pointer;
                            "
                            @click="getDeleteRow(scope.$index)"
                            class="tim-icons icon-trash-simple"
                          ></i>
                        </div>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>
              <div class="row text-right">
                <div class="col-lg"></div>
                <div class="col-lg-2">
                  <p
                    @click="addRow()"
                    style="color: #358CCB; cursor: pointer"
                    class="link"
                  >
                    + Add row
                  </p>
                </div>
              </div>
              <!-- </div> -->
            </card>
          </div>
        </div>
        <div v-if="submit == true" class="row">
          <div class="col-lg"></div>
          <div class="col-lg-4 d-flex">
            <card class="card-eprf">
              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                ANF
              </p>

              <p class="subtitle">Edit ANF</p>
              <base-button type="primary" v-on:click="edit()"
                >Edit ANF</base-button
              >

              <p class="subtitle" style="margin-top: 50px">
                Your Generated ANF
              </p>
              <base-button type="primary" v-on:click="createPDFnew()"
                >View</base-button
              >
            </card>
          </div>
          <div class="col-lg-4 d-flex">
            <card class="card-eprf">
              <p class="subtitle" style="margin-top: 5px">
                Please upload Manifold Plan/Diagram<span style="color: #EC1B23"
                  >*</span
                >
              </p>
              <p class="new-title" style="margin-top: 10px">
                Choose File from Your Desktop
              </p>
              <div class="fileinput">
                <label
                  style="color: white"
                  for="material-safety"
                  type="primary"
                  class="btn"
                >
                  Choose File
                </label>
                <!--  -->
                <div
                  v-if="uploadloadanf == true"
                  class="d-flex justify-content-center spinner"
                >
                  <circle-8></circle-8>
                </div>

                <input
                  accept="application/pdf"
                  id="material-safety"
                  ref="materialsafety"
                  type="file"
                  name="..."
                  class="valid"
                  :multiple="true"
                  aria-invalid="false"
                  style="display: none"
                  v-on:change="onFileChange2"
                />
              </div>
              <div
                style="
                  height: 150px;
                  padding: 0px 20px 20px 0px;
                  margin: 0px 30px 20px 0px;
                "
                class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto"
              >
                <div
                  v-for="(filee, index) in allmaterialname"
                  :key="index"
                  class="row"
                >
                  <div class="col-lg-8">
                    <a :href="filee.fileurl">
                      <base-button class="btn-link btn-primary">
                        {{ filee.filename }}
                      </base-button>
                    </a>
                  </div>
                  <div class="col-lg-4">
                    <base-button
                      class="btn-sm btn-cancel"
                      style="font-size: 12px"
                      @click="removeMaterial(filee.fileid)"
                    >
                      Remove
                    </base-button>
                  </div>
                </div>
              </div>

              <p class="subtitle" style="margin-top: 5px">
                Please upload Stowage Plan <span style="color: #EC1B23">*</span>
              </p>
              <p class="new-title" style="margin-top: 10px">
                Choose File from Your Desktop
              </p>

              <div class="fileinput">
                <label
                  style="color: white"
                  for="stowage-plan"
                  type="primary"
                  class="btn"
                >
                  Choose File
                </label>
                <div
                  class="d-flex justify-content-center spinner"
                  v-if="uploadloadstowage == true"
                >
                  <circle-8></circle-8>
                </div>

                <input
                  accept="application/pdf"
                  id="stowage-plan"
                  ref="stowageplan"
                  type="file"
                  name="..."
                  class="valid"
                  :multiple="true"
                  aria-invalid="false"
                  style="display: none"
                  v-on:change="onFileChange3"
                />
              </div>
              <div
                style="
                  height: 150px;
                  padding: 0px 20px 20px 0px;
                  margin: 0px 30px 20px 0px;
                "
                class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto"
              >
                <div
                  v-for="(filee, index) in allstowagename"
                  :key="index"
                  class="row"
                >
                  <div class="col-lg-8">
                    <a :href="filee.fileurl">
                      <base-button class="btn-link btn-primary">
                        {{ filee.filename }}
                      </base-button>
                    </a>
                    <!-- <p style="padding-left: 15px; color: #A5A5A5" id="file-namee">
                      {{ filee.filename }}
                    </p> -->
                  </div>
                  <div class="col-lg-4">
                    <base-button
                      class="btn-sm btn-cancel"
                      style="font-size: 12px"
                      @click="removeStowage(filee.fileid)"
                    >
                      Remove
                    </base-button>
                  </div>
                </div>
              </div>

              <p class="subtitle" style="margin-top: 5px">
                Please upload any other supporting documents
              </p>
              <p class="new-title" style="margin-top: 10px">
                Choose File from Your Desktop
              </p>

              <div class="fileinput">
                <label
                  style="color: white"
                  for="file-upload"
                  type="primary"
                  class="btn"
                >
                  Choose File
                </label>
                <div
                  class="d-flex justify-content-center spinner"
                  v-if="uploadloadrecurring == true"
                >
                  <circle-8></circle-8>
                </div>

                <input
                  accept="application/pdf"
                  id="file-upload"
                  ref="file"
                  type="file"
                  name="..."
                  class="valid"
                  :multiple="true"
                  aria-invalid="false"
                  style="display: none"
                  v-on:change="onFileChange"
                />
              </div>
              <div
                style="
                  height: 150px;
                  padding: 0px 20px 20px 0px;
                  margin: 0px 30px 20px 0px;
                "
                class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto"
              >
                <div
                  v-for="(file, index) in allfilename"
                  :key="index"
                  class="row"
                >
                  <div class="col-lg-8">
                    <a :href="file.fileurl">
                      <base-button class="btn-link btn-primary">
                        {{ file.filename }}
                      </base-button>
                    </a>
                  </div>
                  <div class="col-lg-4">
                    <!-- <p v-if="selectedFileName" style="font-size: 12px; color: #aaa; opacity: 0.5"
                      @click="removeFile(file.fileid)">
                      Remove
                    </p> -->
                    <base-button
                      class="btn-sm btn-cancel"
                      style="font-size: 12px"
                      @click="removeFile(file.fileid)"
                    >
                      Remove
                    </base-button>
                  </div>
                </div>
              </div>
            </card>
          </div>
          <div class="col-lg"></div>
        </div>
        <div v-if="submit == true" class="row">
          <div class="col-lg"></div>
          <div class="col-lg-3 text-right">
            <base-button :disabled="candone" wide type="primary" @click="redirect()">
              Done
            </base-button>
          </div>
        </div>
        <div v-if="submit == false" class="row">
          <div class="col-lg"></div>
          <div class="col-lg-3 text-right">
            <!-- <base-button type="danger" v-on:click="prevTab()">Back</base-button
        >&nbsp;
         -->

            <base-button
              wide
              type="danger"
              @click.native="exitTab"
              class="btn-dispute"
            >
              Back
            </base-button>

            &nbsp;

            <base-button
              :disabled="
                arrival === null ||
                arrival === '' ||
                departure === null ||
                departure === '' ||
                warning === true
              "
              type="primary"
              v-on:click="submitJobRequest()"
              >Submit</base-button
            >
          </div>
        </div>
        <div class="row">
          <div class="col-lg"></div>
          <div v-if="!arrival && !departure" class="col-lg-3 text-right">
            <p style="color: #ff0000; font-size: 12px">
              Please select arrival and departure date.
            </p>
          </div>
          <div v-else-if="!arrival" class="col-lg-3 text-right">
            <p style="color: #ff0000; font-size: 12px">
              Please select arrival date.
            </p>
          </div>
          <div v-else-if="!departure" class="col-lg-3 text-right">
            <p style="color: #ff0000; font-size: 12px">
              Please select departure date.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-lg text-right">
            <p style="color: #ff0000; font-size: 12px">
              {{ errmsg }}
            </p>
          </div>
        </div>
        <div v-if="submit == false" class="row">
          <div class="col-lg"></div>
          <div class="col-lg-3 text-right">
            <!--  -->
            <base-button
              :disabled="
                arrival === null ||
                arrival === '' ||
                departure === null ||
                departure === ''
              "
              class="btn-link"
              style="
                color: #052d72;
                cursor: pointer;
                text-decoration: underline;
              "
              @click="saveDraft()"
            >
              Save Draft
            </base-button>
          </div>
        </div>
      </div>

      <div v-if="submitted == 'edit'">
        <div v-if="submit == false" class="row">
          <div class="col-lg-4">
            <card class="card-eprf">
              <div
                class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto"
              >
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  JOB DETAILS
                </p>

                <p class="new-title">Job Reference No.</p>
                <p class="subtitle">{{ this.jobno }}</p>

                <p class="new-title">
                  Arrival ETA <span style="color: #EC1B23">*</span>
                </p>
                <el-date-picker
                  v-model="arrival"
                  placeholder="Select time"
                  :picker-options="arrivalOptions"
                  @change="checkArrival"
                ></el-date-picker>
                <!--{{ this.arrival }}-->

                <p class="new-title">
                  Departure (ETD) <span style="color: #EC1B23">*</span>
                </p>
                <el-date-picker
                  v-model="departure"
                  placeholder="Select time"
                  :picker-options="departureOptions"
                  @change="getData()"
                ></el-date-picker>
                <!-- {{ this.departure }} -->

                <p class="new-title">
                  Previous Port <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input
                    type="text"
                    v-model="previousport"
                    :class="{ 'custom-input': true }"
                  />
                </div>

                <p class="new-title">
                  Next Port <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input
                    type="text"
                    v-model="nextport"
                    :class="{ 'custom-input': true }"
                  />
                </div>

                <p class="new-title">
                  Last Port When Generated Waste Delivered
                  <span style="color: #EC1B23">*</span>
                </p>
                <div style="padding-right: 30px">
                  <input
                    type="text"
                    v-model="lastport"
                    :class="{ 'custom-input': true }"
                  />
                </div>

                <p class="new-title">
                  Date When Generated Waste Delivered
                  <span style="color: #EC1B23">*</span>
                </p>
                <el-date-picker
                  v-model="lastportdate"
                  placeholder="Select date"
                  :picker-options="arrivalOptions"
                ></el-date-picker>

                <p class="new-title">Ships <span style="color: #EC1B23">*</span></p>
                <el-select
                  class="select-info tab select-width"
                  popper-class="custom-dropdown"
                  placeholder="Select"
                  v-model="selects.ship"
                  style="width: 90%; border-bottom: 1px solid lightgray"
                  @change="getType()"
                  filterable
                >
                  <el-option
                    v-for="option in selects.ships"
                    class="select-info custom-option"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>

                <p class="new-title">
                  Service Location <span style="color: #EC1B23">*</span>
                </p>
                <el-select
                  class="select-info tab select-width"
                  popper-class="custom-dropdown"
                  placeholder="Select"
                  v-model="selects.location"
                  style="width: 90%; border-bottom: 1px solid lightgray"
                  @change="getType()"
                  filterable
                >
                  <el-option
                    v-for="option in selects.locations"
                    class="select-info custom-option"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>

                <p class="new-title">
                  Service Location Collection <span style="color: #EC1B23">*</span>
                </p>
                <el-select
                  class="select-info tab select-width"
                  popper-class="custom-dropdown"
                  placeholder="Select"
                  v-model="selects.collection"
                  style="width: 90%; border-bottom: 1px solid lightgray"
                  filterable
                >
                  <el-option
                    v-for="option in selects.collections"
                    class="select-info custom-option"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>

                <p class="new-title">
                  PIC Full Name <span style="color: #EC1B23">*</span>
                </p>
                <el-select
                  class="select-info tab select-width"
                  popper-class="custom-dropdown"
                  placeholder="Select"
                  v-model="selects.pic"
                  style="width: 90%; border-bottom: 1px solid lightgray"
                  @change="getType()"
                  filterable
                >
                  <el-option
                    v-for="option in selects.pics"
                    class="select-info custom-option"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>

                <p class="new-title">PIC Phone No.</p>
                <p class="subtitle">{{ phoneno }}</p>

                <p class="new-title">PIC Fax No.</p>
                <p class="subtitle">{{ faxno }}</p>

                <p class="new-title">PIC Email</p>
                <p class="subtitle">{{ email }}</p>
              </div>
            </card>
          </div>
          <div class="col-lg-8">
            <card
              style="
                box-shadow: none;
                padding: 0px 0px 30px 30px;
                height: 630px;
                color: #A5A5A5;
                background-color: white;
              "
            >
              <!-- <div class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto"> -->
              <div class="row" style="display: flex">
                <div class="col-lg">
                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                    WASTE DETAILS
                  </p>
                </div>
              </div>
              <div
                id="tableku"
                v-if="this.load == false"
                style="height: 500px; overflow: auto; overflow-x: hidden"
              >
                <div class="row">
                  <div class="col-lg">
                    <el-table
                      :data="tableDatas"
                      :header-cell-style="{
                        background: '#358DCC',
                        border: 'transparent',
                        'font-size': '14px',
                        'font-weight': '400',
                        color: '#FFFFFF',
                        'word-wrap': 'break-word',
                      }"
                      :cell-style="{ fontColor: '#707070' }"
                      :row-style="tableRowClassName"
                      style="color: #707070"
                    >
                      <el-table-column label="NO." width="50" align="center">
                        <div slot-scope="scope">
                          <p style="color: #707070">
                            {{ scope.$index + 1 }}
                          </p>
                        </div>
                      </el-table-column>
                      <el-table-column
                        :min-width="300"
                        align="center"
                        prop="wastetype"
                        label="WASTE TYPE"
                      >
                        <div slot-scope="scope">
                          <div align="center">
                            <div class="row">
                              <div style="position: relative">
                                <span
                                  style="
                                    color: #EC1B23;
                                    position: absolute;
                                    bottom: 17%;
                                    right: 0;
                                  "
                                  >*</span
                                >
                                <!-- @change="
                                    getWasteSubType(scope.row, scope.$index)
                                  " -->
                                <el-select
                                  class="select-info tab select-width"
                                  placeholder="Select waste type"
                                  popper-class="custom-dropdown"
                                  v-model="scope.row.wastetype"
                                  style="width: 100%"
                                  @change="getWasteSubType(scope.$index)"
                                  filterable
                                >
                                  <el-option
                                    v-for="option in selects.wastetypes"
                                    class="select-info custom-option"
                                    :value="option.value"
                                    :label="option.label"
                                    :key="option.value"
                                  ></el-option>
                                </el-select>
                              </div>
                            </div>

                            <!-- <span style="color: #EC1B23;">*</span> -->

                            <!-- {{ scope.row.wastetype }} -->
                            <!-- <div class="row">
                            <div style="position: relative;">
                              <span style="color: #EC1B23; position: absolute; bottom: 17%; right: 0;">*</span>
                              <el-select class="select-info tab select-width" popper-class="custom-dropdown"
                                placeholder="Sub-waste Type" v-model="scope.row.swcode" style="width: 100%"
                                @change="getType(scope.row.swcode)" filterable>
                                <el-option v-for="option in selects.wastetypes[scope.$index]
        .swcodes" class="select-info custom-option" :value="option.value" :label="option.label" :key="option.value"
                                  style="width: 300px;height: auto; white-space: normal"></el-option>
                              </el-select>
                            </div>
                          </div> -->

                            <div class="row">
                              <div style="position: relative">
                                <span
                                  style="
                                    color: #EC1B23;
                                    position: absolute;
                                    bottom: 17%;
                                    right: 0;
                                  "
                                  >*</span
                                >
                                <el-select
                                  class="select-info tab select-width"
                                  popper-class="custom-dropdown"
                                  placeholder="Sub-waste Type"
                                  v-model="scope.row.swcode"
                                  style="width: 100%"
                                  @change="
                                    getTypee(
                                      scope.$index,
                                      scope.row.swcode,
                                      scope.row
                                    )
                                  "
                                  filterable
                                >
                                  <!-- <el-option
                                    v-for="option in selects.wastetypes[
                                      scope.$index
                                    ].swcodes"
                                    class="select-info custom-option"
                                    :value="option.value"
                                    :label="option.label"
                                    :key="option.value"
                                    style="
                                      width: 300px;
                                      height: auto;
                                      white-space: normal;
                                    "
                                  >
                                  </el-option> -->
                                  <el-option
                                    v-for="option in scope.row.wastesubtypes"
                                    class="select-info custom-option"
                                    :value="option.value"
                                    :label="option.label"
                                    :key="option.value"
                                    style="
                                      width: 300px;
                                      height: auto;
                                      white-space: normal;
                                    "
                                  >
                                  </el-option>
                                </el-select>
                              </div>
                            </div>

                            <div
                              v-if="scope.row.check == true"
                              style="width: 100%"
                              align="left"
                            >
                              <input
                                type="text"
                                v-model="scope.row.specifywastetype"
                                :class="{ 'custom-input': true }"
                                @focus="handleFocus(scope.row)"
                                
                              />
                              <!-- @input="handleInput(scope.row.specifywastetype)" -->
                              <p
                                v-if="scope.row.buttonadd === true"
                                @click="
                                  handleSpecify(
                                    scope.row.specifywastetype,
                                    scope.row
                                  )
                                "
                                style="
                                  text-align: right;
                                  color: #358CCB;
                                  cursor: pointer;
                                "
                                class="link"
                              >
                                + Add new sub waste type
                                <span style="color: #EC1B23">*</span>
                              </p>
                            </div>

                            <!-- <div v-if="scope.row.wastetype == '6'" style="width: 80%" align="left">
                            <span style="color: #EC1B23;">*</span>
                            <input type="text" v-model="scope.row.specifywastetype" :class="{ 'custom-input': true }"
                              @focus="handleFocus(scope.row)" @input="handleInput(scope.row.specifywastetype)" />
                            <p v-if="scope.row.buttonadd === true" @click="
        handleSpecify(
          scope.row.specifywastetype,
          scope.row
        )
        " style="
                                text-align: right;
                                color: #358CCB;
                                cursor: pointer;
                              " class="link">
                              + Add new sub waste type
                            </p>
                          </div> -->

                            <!-- <div v-if="(scope.row.wastetype == '8' &&
        scope.row.swcode == '26') ||
        (scope.row.wastetype == '8' &&
          scope.row.swcode == '27')
        " style="width: 80%" align="left">
                            <span style="color: #EC1B23;">*</span>
                            <input type="text" v-model="scope.row.specifywastetype" :class="{ 'custom-input': true }"
                              @focus="handleFocus(scope.row)" @input="handleInput(scope.row.specifywastetype)" />
                            <p v-if="scope.row.buttonadd === true" @click="
        handleSpecify(
          scope.row.specifywastetype,
          scope.row
        )
        " style="
                                text-align: right;
                                color: #358CCB;
                                cursor: pointer;
                              " class="link">
                              + Add new sub waste type
                            </p>
                          </div> -->
                          </div>
                        </div>
                      </el-table-column>
                      <el-table-column
                        :min-width="250"
                        align="center"
                        prop="wasteqty"
                        label="WASTE QTY."
                      >
                        <div slot-scope="{ row }">
                          <div align="center">
                            <div class="row">
                              <div class="col-lg-8">
                                <div style="width: 100%" align="left">
                                  <input
                                    type="number"
                                    :min="0"
                                    v-model="row.estqty"
                                    :class="{ 'custom-input': true }"
                                  />
                                </div>
                              </div>
                              <div class="col-lg">
                                <p class="new-title">
                                  <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="is metric cubic"
                                    placement="top-start"
                                  >
                                    <p class="new-title">
                                      CBM<span style="color: #EC1B23">*</span>
                                    </p>
                                  </el-tooltip>
                                </p>
                              </div>
                            </div>
                            <!-- <div class="row">
                            <div class="col-lg text-left">
                              <span style="color: #EC1B23;">*</span>
                              <el-select class="select-info tab select-width" placeholder="Select waste unit"
                                v-model="row.measurement" style="width: 100%" @change="getType()" filterable>
                                <el-option v-for="option in selects.measurements" class="select-info custom-option"
                                  :value="option.value" :label="option.label" :key="option.value"></el-option>
                              </el-select>

                            </div>
                          </div> -->
                          </div>
                        </div>
                      </el-table-column>
                      <el-table-column
                        :min-width="260"
                        align="center"
                        prop="storage"
                        label="MAX DEDICATED STORAGE CAPACITY"
                      >
                        <div slot-scope="{ row }">
                          <div align="center">
                            <div class="row">
                              <div class="col-lg-8">
                                <div style="width: 100%" align="left">
                                  <!-- <span style="color: #EC1B23;">*</span> -->
                                  <input
                                    type="number"
                                    :min="0"
                                    v-model="row.storage"
                                    :class="{ 'custom-input': true }"
                                  />
                                </div>
                              </div>
                              <div class="col-lg">
                                <p class="new-title">
                                  <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="is metric cubic"
                                    placement="top-start"
                                  >
                                    <p class="new-title">
                                      CBM<span style="color: #EC1B23">*</span>
                                    </p>
                                  </el-tooltip>
                                </p>
                              </div>

                              <!-- </div> -->
                            </div>
                            <!-- <div class="row">
                            <div class="col-lg text-left">
                              <span style="color: #EC1B23;">*</span>
                              <el-select class="select-info tab select-width" placeholder="Select waste unit"
                                v-model="row.measurement1" style="width: 100%" @change="getType()" filterable>
                                <el-option v-for="option in selects.measurement1s" class="select-info custom-option"
                                  :value="option.value" :label="option.label" :key="option.value"></el-option>
                              </el-select>

                            </div>
                          </div> -->
                          </div>
                        </div>
                      </el-table-column>
                      <el-table-column
                        :min-width="250"
                        align="center"
                        prop="retain"
                        label="WASTE AMOUNT RETAINED ON-BOARD"
                      >
                        <div slot-scope="{ row }">
                          <div align="center">
                            <div class="row">
                              <div class="col-lg-8">
                                <div style="width: 100%" align="left">
                                  <input
                                    type="number"
                                    :min="0"
                                    v-model="row.retain"
                                    :class="{ 'custom-input': true }"
                                  />
                                </div>
                              </div>
                              <div class="col-lg">
                                <p class="new-title">
                                  <el-tooltip
                                    class="item"
                                    effect="dark"
                                    content="is metric cubic"
                                    placement="top-start"
                                  >
                                    <p class="new-title">
                                      CBM<span style="color: #EC1B23">*</span>
                                    </p>
                                  </el-tooltip>
                                </p>
                              </div>
                            </div>
                            <!-- <div class="row">
                            <div class="col-lg text-left">
                              <span style="color: #EC1B23;">*</span>
                              <el-select class="select-info tab select-width" placeholder="Select waste unit"
                                v-model="row.measurement2" style="width: 100%" @change="getType()" filterable>
                                <el-option v-for="option in selects.measurement2s" class="select-info custom-option"
                                  :value="option.value" :label="option.label" :key="option.value"></el-option>
                              </el-select>
                            </div>
                          </div> -->
                          </div>
                        </div>
                      </el-table-column>
                      <el-table-column
                        :min-width="200"
                        align="center"
                        prop="remarks"
                        label="REMARKS"
                      >
                        <div slot-scope="{ row }">
                          <input
                            type="text"
                            v-model="row.remarks"
                            :class="{ 'custom-input': true }"
                          />
                          <!-- <textarea
                  type="textarea"
                  placeholder="Remarks..."
                  v-model="remarks"
                  :class="{ 'custom-input-2': true }"
                ></textarea> -->
                        </div>
                      </el-table-column>
                      <el-table-column
                        width="50"
                        align="center"
                        prop="delete"
                        label=""
                      >
                        <div slot-scope="scope">
                          <i
                            v-if="scope.$index != 0"
                            style="
                              position: absolute;
                              top: 50%;
                              left: 50%;
                              transform: translate(-50%, -50%);
                              color: #ff0000;
                              font-size: 15px;
                              font-weight: 900;
                              cursor: pointer;
                            "
                            @click="getDeleteRow(scope.$index)"
                            class="tim-icons icon-trash-simple"
                          ></i>
                        </div>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>
              <div class="row text-right">
                <div class="col-lg"></div>
                <div class="col-lg-2">
                  <p
                    @click="addRow()"
                    style="color: #358CCB; cursor: pointer"
                    class="link"
                  >
                    + Add row
                  </p>
                </div>
              </div>
              <!-- </div> -->
            </card>
          </div>
        </div>
        <div v-if="submit == true" class="row">
          <div class="col-lg"></div>
          <div class="col-lg-4 d-flex">
            <card class="card-eprf">
              <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                ANF
              </p>

              <p class="subtitle">Edit ANF</p>
              <base-button type="primary" v-on:click="edit()"
                >Edit ANF</base-button
              >

              <p class="subtitle" style="margin-top: 50px">
                Your Generated ANF
              </p>
              <base-button type="primary" v-on:click="createPDFnew()"
                >View</base-button
              >
            </card>
          </div>
          <div class="col-lg-4 d-flex">
            <card class="card-eprf">
              <p class="subtitle" style="margin-top: 5px">
                Please upload Manifold Plan/Diagram<span style="color: #EC1B23"
                  >*</span
                >
              </p>
              <p class="new-title" style="margin-top: 10px">
                Choose File from Your Desktop
              </p>
              <div class="fileinput">
                <label
                  style="color: white"
                  for="material-safety"
                  type="primary"
                  class="btn"
                >
                  Choose File
                </label>
                <!--  -->
                <div
                  v-if="uploadloadanf == true"
                  class="d-flex justify-content-center spinner"
                >
                  <circle-8></circle-8>
                </div>

                <input
                  accept="application/pdf"
                  id="material-safety"
                  ref="materialsafety"
                  type="file"
                  name="..."
                  class="valid"
                  :multiple="true"
                  aria-invalid="false"
                  style="display: none"
                  v-on:change="onFileChange2"
                />
              </div>
              <div
                style="
                  height: 150px;
                  padding: 0px 20px 20px 0px;
                  margin: 0px 30px 20px 0px;
                "
                class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto"
              >
                <div
                  v-for="(filee, index) in allmaterialname"
                  :key="index"
                  class="row"
                >
                  <div class="col-lg-8">
                    <a :href="filee.fileurl">
                      <base-button class="btn-link btn-primary">
                        {{ filee.filename }}
                      </base-button>
                    </a>
                  </div>
                  <div class="col-lg-4">
                    <base-button
                      class="btn-sm btn-cancel"
                      style="font-size: 12px"
                      @click="removeMaterial(filee.fileid)"
                    >
                      Remove
                    </base-button>
                  </div>
                </div>
              </div>

              <p class="subtitle" style="margin-top: 5px">
                Please upload Stowage Plan <span style="color: #EC1B23">*</span>
              </p>
              <p class="new-title" style="margin-top: 10px">
                Choose File from Your Desktop
              </p>

              <div class="fileinput">
                <label
                  style="color: white"
                  for="stowage-plan"
                  type="primary"
                  class="btn"
                >
                  Choose File
                </label>
                <div
                  class="d-flex justify-content-center spinner"
                  v-if="uploadloadstowage == true"
                >
                  <circle-8></circle-8>
                </div>

                <input
                  accept="application/pdf"
                  id="stowage-plan"
                  ref="stowageplan"
                  type="file"
                  name="..."
                  class="valid"
                  :multiple="true"
                  aria-invalid="false"
                  style="display: none"
                  v-on:change="onFileChange3"
                />
              </div>
              <div
                style="
                  height: 150px;
                  padding: 0px 20px 20px 0px;
                  margin: 0px 30px 20px 0px;
                "
                class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto"
              >
                <div
                  v-for="(filee, index) in allstowagename"
                  :key="index"
                  class="row"
                >
                  <div class="col-lg-8">
                    <a :href="filee.fileurl">
                      <base-button class="btn-link btn-primary">
                        {{ filee.filename }}
                      </base-button>
                    </a>
                    <!-- <p style="padding-left: 15px; color: #A5A5A5" id="file-namee">
                      {{ filee.filename }}
                    </p> -->
                  </div>
                  <div class="col-lg-4">
                    <base-button
                      class="btn-sm btn-cancel"
                      style="font-size: 12px"
                      @click="removeStowage(filee.fileid)"
                    >
                      Remove
                    </base-button>
                  </div>
                </div>
              </div>

              <p class="subtitle" style="margin-top: 5px">
                Please upload any other supporting documents
              </p>
              <p class="new-title" style="margin-top: 10px">
                Choose File from Your Desktop
              </p>

              <div class="fileinput">
                <label
                  style="color: white"
                  for="file-upload"
                  type="primary"
                  class="btn"
                >
                  Choose File
                </label>
                <div
                  class="d-flex justify-content-center spinner"
                  v-if="uploadloadrecurring == true"
                >
                  <circle-8></circle-8>
                </div>

                <input
                  accept="application/pdf"
                  id="file-upload"
                  ref="file"
                  type="file"
                  name="..."
                  class="valid"
                  :multiple="true"
                  aria-invalid="false"
                  style="display: none"
                  v-on:change="onFileChange"
                />
              </div>
              <div
                style="
                  height: 150px;
                  padding: 0px 20px 20px 0px;
                  margin: 0px 30px 20px 0px;
                "
                class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto"
              >
                <div
                  v-for="(file, index) in allfilename"
                  :key="index"
                  class="row"
                >
                  <div class="col-lg-8">
                    <a :href="file.fileurl">
                      <base-button class="btn-link btn-primary">
                        {{ file.filename }}
                      </base-button>
                    </a>
                  </div>
                  <div class="col-lg-4">
                    <!-- <p v-if="selectedFileName" style="font-size: 12px; color: #aaa; opacity: 0.5"
                      @click="removeFile(file.fileid)">
                      Remove
                    </p> -->
                    <base-button
                      class="btn-sm btn-cancel"
                      style="font-size: 12px"
                      @click="removeFile(file.fileid)"
                    >
                      Remove
                    </base-button>
                  </div>
                </div>
              </div>
            </card>
          </div>
          <div class="col-lg"></div>
        </div>
        <div v-if="submit == true" class="row">
          <div class="col-lg"></div>
          <div class="col-lg-3 text-right">
            <base-button :disabled="candone" wide type="primary" @click="redirect()">
              Done
            </base-button>
          </div>
        </div>
        <div v-if="submit == false" class="row">
          <div class="col-lg"></div>
          <div class="col-lg-3 text-right">
            <!-- <base-button type="danger" v-on:click="prevTab()">Back</base-button
        >&nbsp;
         -->

            <base-button
              wide
              type="danger"
              @click.native="exitTab"
              class="btn-dispute"
            >
              Back
            </base-button>

            &nbsp;

            <base-button
              :disabled="
                arrival === null ||
                arrival === '' ||
                departure === null ||
                departure === '' ||
                warning === true
              "
              type="primary"
              v-on:click="submitJobRequest()"
              >Submit</base-button
            >
          </div>
        </div>
        <div class="row">
          <div class="col-lg"></div>
          <div v-if="!arrival && !departure" class="col-lg-3 text-right">
            <p style="color: #ff0000; font-size: 12px">
              Please select arrival and departure date.
            </p>
          </div>
          <div v-else-if="!arrival" class="col-lg-3 text-right">
            <p style="color: #ff0000; font-size: 12px">
              Please select arrival date.
            </p>
          </div>
          <div v-else-if="!departure" class="col-lg-3 text-right">
            <p style="color: #ff0000; font-size: 12px">
              Please select departure date.
            </p>
          </div>
        </div>
        <div v-if="submit == false" class="row">
          <div class="col-lg"></div>
          <div class="col-lg-3 text-right">
            <!--  -->
            <base-button
              :disabled="
                arrival === null ||
                arrival === '' ||
                departure === null ||
                departure === ''
              "
              class="btn-link"
              style="
                color: #052d72;
                cursor: pointer;
                text-decoration: underline;
              "
              @click="saveDraft()"
            >
              Save Draft
            </base-button>
          </div>
        </div>
      </div>

      <div v-if="submitted == 'view'">
        <div class="row">
          <div class="col-lg-4 d-flex">
            <card
              style="
                box-shadow: none;
                color: #A5A5A5;
                padding: 0px 10px 30px 0px;

                background-color: white;
              "
            >
              <div
                class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto"
              >
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  JOB DETAILS
                </p>
                <div
                  style="height: 520px; overflow: scroll; overflow-x: hidden"
                >
                  <p class="new-title">Job Reference No.</p>
                  <p class="subtitle">{{ this.jobno }}</p>

                  <p class="new-title">Arrival ETA</p>
                  <p class="subtitle">{{ this.arrivaletasubmit }}</p>

                  <p class="new-title">Departure (ETD)</p>
                  <p class="subtitle">{{ this.departureetasubmit }}</p>

                  <p class="new-title">Previous Port</p>
                  <p class="subtitle">{{ this.previousportsubmit }}</p>

                  <p class="new-title">Next Port</p>
                  <p class="subtitle">{{ this.nextportsubmit }}</p>

                  <p class="new-title">
                    Last Port When Generated Waste Delivered
                  </p>
                  <p class="subtitle">{{ this.lastportsubmit }}</p>

                  <p class="new-title">
                    Last Date When Generated Waste Delivered
                  </p>
                  <p class="subtitle">{{ this.lastdate }}</p>

                  <p class="new-title">Ship</p>
                  <p class="subtitle">{{ this.shipsubmit }}</p>

                  <p class="new-title">Service Location</p>
                  <p class="subtitle">{{ this.servicelocatiobsubmit }}</p>

                  <p class="new-title">PIC Full Name</p>
                  <p class="subtitle">{{ this.picsubmit }}</p>

                  <p class="new-title">PIC Phone No.</p>
                  <p class="subtitle">{{ phoneno }}</p>

                  <p class="new-title">PIC Fax No.</p>
                  <p class="subtitle">{{ faxno }}</p>

                  <p class="new-title">PIC Email</p>
                  <p class="subtitle">{{ email }}</p>
                </div>
              </div>
            </card>
          </div>
          <div class="col-lg-8 d-flex">
            <!-- style="
            box-shadow: none;
            padding: 0px 0px 30px 30px;
            height: 630px;
            color: #A5A5A5;
            background-color: white;
          " -->
            <card class="card-eprf">
              <div class="row" style="display: flex">
                <div class="col-lg">
                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                    WASTE DETAILS
                  </p>
                </div>
              </div>
              <!-- <div style="height: 525px; overflow: scroll; overflow-x: hidden"> -->

              <div
                v-if="this.load == false"
                style="height: 500px; overflow: auto; overflow-x: hidden"
              >
                <div class="row">
                  <div class="col-lg">
                    <el-table
                      :data="tableDatas"
                      :header-cell-style="{
                        background: '#358DCC',
                        border: 'transparent',
                        'font-size': '14px',
                        'font-weight': '400',
                        color: '#FFFFFF',
                        
                      }"
                      :cell-style="{ fontColor: '#707070' }"
                      :row-style="tableRowClassName"
                      style="color: #707070"
                    >
                      <el-table-column label="NO." width="50" align="center">
                        <div slot-scope="scope">
                          <p style="color: #707070">
                            {{ scope.$index + 1 }}
                          </p>
                        </div>
                      </el-table-column>
                      <el-table-column
                        :min-width="200"
                        align="center"
                        prop="wastetype"
                        label="WASTE TYPE"
                      >
                        <div slot-scope="{ row }">
                          <div align="left">
                            <p style="color: #707070; word-break: break-word;">
                              Waste Type: {{ row.wastetypename }}
                            </p>
                            <p style="color: #707070; word-break: break-word;">
                              Waste Sub Type: {{ row.swcodename }}
                            </p>
                          </div>
                        </div>
                      </el-table-column>
                      <el-table-column
                        :min-width="60"
                        align="center"
                        prop="wasteqty"
                        label="WASTE QTY."
                      >
                      </el-table-column>
                      <el-table-column
                        :min-width="150"
                        align="center"
                        prop="storage"
                        label="MAX DEDICATED STORAGE CAPACITY"
                      >
                      </el-table-column>
                      <el-table-column
                        :min-width="155"
                        align="center"
                        prop="retain"
                        label="WASTE AMOUNT RETAINED ON-BOARD"
                      >
                      </el-table-column>
                      <el-table-column
                        :min-width="200"
                        align="center"
                        prop="remarks"
                        label="REMARKS"
                      >
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>
              <!-- hide dulu lepas uat sambung -->
              <!-- <div class="row"
                  style="position: absolute; bottom: 20px; width: calc(100% - 30px); display: flex; justify-content: space-between;">
                  <div class="col-lg-4" style="display: flex; flex: 1; justify-content: left; align-items: left;">
                    <div class="col" style="text-align: left;">
                      <p style="color: #358CCB; font-size: 18px; font-weight: 600">
                        MANIFOLD PLAN/DIAGRAM
                      </p>
                      <base-button @click="modals.msdsdoc = true" type="primary">View</base-button>
                    </div>
                  </div>
                  <div class="col-lg-4" style="display: flex; flex: 1; justify-content: left; align-items: left;">
                    <div class="col" style="text-align: left;">
                      <p style="color: #358CCB; font-size: 18px; font-weight: 600">
                        STOWAGE PLAN
                      </p>
                      <base-button @click="modals.stowagedoc = true" type="primary">View</base-button>
                    </div>
                  </div>
                  <div class="col-lg-4" style="display: flex; flex: 1; justify-content: left; align-items: left;">
                    <div class="col" style="text-align: left;">
                      <p style="color: #358CCB; font-size: 18px; font-weight: 600">
                        OTHER SUPPORTING DOCUMENT
                      </p>
                      <base-button @click="modals.supportdoc = true" type="primary">View</base-button>
                    </div>
                  </div>
                </div> -->
              <!-- </div> -->
            </card>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4"></div>

          <div class="col-lg-3 text-left">
            <base-button @click="modals.supportdoc = true" type="primary"
              >View Documents</base-button
            >
          </div>
          <div class="col-lg"></div>
          <div class="col-lg-3 text-right">
            <!-- <base-button type="danger" v-on:click="prevTab()">Back</base-button>&nbsp; -->
            <base-button type="primary" v-on:click="createPDFnew()"
              >Generate ANF</base-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Option,
  Select,
  DatePicker,
  Tooltip,
  Button,
} from "element-ui";
import { ImageUpload, Modal } from "src/components";
import { Circle8 } from "vue-loading-spinner";
import moment from "moment";
import swal from "sweetalert2";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { modal } from "src/components/variable.js";
import { getStorage } from "../../../../util/storage";
import StatusModal from "src/components/StatusModal.vue";
import { BCard } from "bootstrap-vue";

export default {
  // props: ["parentData"],
  components: {
    StatusModal,
    ImageUpload,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tooltip.name]: Tooltip,
    [Button.name]: Button,
    Circle8,
    Modal,
    BCard,
  },
  // props: ["test1"],
  data() {
    return {
      selectedfirst: 0,
      warning: false,
      errmsg: "",
      msdsopen: false,
      stowageopen: false,
      otheropen: false,
      quoopen: false,
      msds: "",
      stowage: "",
      otherdoc: "",
      modal: modal,
      uploadloadanf: false,
      uploadloadstowage: false,
      uploadloadrecurring: false,

      phoneno: "",
      faxno: "",
      email: "",
      selectedIndex: null,
      // check: false,
      //submitted data
      arrivaletasubmit: "",
      departureetasubmit: "",
      previousportsubmit: "",
      nextportsubmit: "",
      lastportsubmit: "",
      lastdate: "",
      shipsubmit: "",
      servicelocatiobsubmit: "",
      picsubmit: "",

      showOverlay: false,
      uploadload: false,
      selectedFileName: "",
      allfilename: [],
      allmaterialname: [],
      allstowagename: [],
      allquodocname: [],
      wcodone: false,
      jobreferenceno: "",
      picphoneno: "",
      picfaxno: "",
      picemail: "",

      picdetail: [
        {
          id: 0,
          name: "",
          phoneno: "",
          faxno: "",
          email: "",
        },
      ],

      arrival: null,
      departure: null,
      arrivalOptions: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 86400000;
        },
      },
      departureOptions: {
        disabledDate: (time) => {
          return this.arrival
            ? time.getTime() < new Date(this.arrival).getTime()
            : false;
        },
      },
      previousport: "",
      nextport: "",
      lastport: "",
      lastportdate: "",
      companyname: "",
      companyaddress: "",
      companyphoneno: "",
      companyfaxno: "",

      shipname: "",
      imono: "",
      shiptype: "",
      grosstonnage: "",
      deadweight: "",
      operatorname: "",
      callsign: "",
      flagstate: "",
      cert: "",

      wastearray: [],

      referenceno: "",
      wastejobid: 0,

      load: false,
      img: null,
      imgdescription: "",
      image: "",
      imagebase64: "",
      images: {
        regular: null,
      },

      specify: "",
      specifywastetype: "",

      newwastetypeid: null,

      deliveryterm: "",
      paymentterm: "",

      jobno: "",
      estimatequatity: "",

      wasteorigin: "",
      remarks: "",

      selects: {
        location: "",
        locations: [
          { value: 1, label: "Workshop Asia Port, CT1" },
          { value: 2, label: "Workshop Asia Port, CT1" },
          { value: 3, label: "Others (Please specify)" },
        ],

        pic: "",
        pics: [
          { value: 1, label: "Amirah binti Azman" },
          { value: 2, label: "Yahya Abd Rahman" },
          { value: 3, label: "Haziq Haikal bin Ayub" },
        ],

        wastetype: "",
        wastetypes: [
          { value: 1, label: "Scheduled Waste", swcodes: [] },
          { value: 2, label: "Garbage", swcodes: [] },
          { value: 3, label: "Sewage", swcodes: [] },
          { value: 4, label: "Scrap", swcodes: [] },
          { value: 5, label: "Others", swcodes: [] },
        ],
        wastesubtypes: [],

        measurement: "MT",
        measurements: [
          { value: "MT", label: "MT" },
          { value: "M³", label: "M³" },
        ],

        measurement1: "MT",
        measurement1s: [
          { value: "MT", label: "MT" },
          { value: "M³", label: "M³" },
        ],

        measurement2: "MT",
        measurement2s: [
          { value: "MT", label: "MT" },
          { value: "M³", label: "M³" },
        ],
        collection: "",
        collections: [],
        ship: "",
        ships: [],
      },

      wastedetail: [
        {
          prop: "wastetype",
          label: "Waste Type",
        },
        {
          prop: "wasteqty",
          label: "Waste Qty.",
        },
        {
          prop: "storage",
          label: "Max Dedicated Storage Capacity",
        },
        {
          prop: "retain",
          label: "Waste Amount Retained On-board",
        },
        {
          prop: "remarks",
          label: "Remarks",
        },
      ],

      tableDatas: [
        {
          id: "1",
          check: false,
          buttonadd: true,
          wastetype: "",
          swcode: "",
          newwastetypeid: "",
          wasteqty: "",
          storage: "",
          retain: "",
          remarks: "",
        },
        // {
        //   id: "1",
        //   buttonadd: true,
        //   wastetype: "",
        //   swcode: "",
        //   newwastetypeid: "",
        //   wasteqty: "",
        //   storage: "",
        //   retain: "",
        //   remarks: "",
        // },
        // {
        //   id: "1",
        //   buttonadd: true,tabledatas:
        //   wastetype: "",
        //   swcode: "",
        //   newwastetypeid: "",
        //   wasteqty: "",
        //   storage: "",
        //   retain: "",
        //   remarks: "",
        // },
      ],

      modals: {
        submit: false,
        warningsubmit: false,
        successModal: false,
        removeModal: false,
        failedModal: false,

        msdsdoc: false,
        stowagedoc: false,
        supportdoc: false,
      },
      message: "",
      // hmm
      submit: false,

      submitted: "add",

      documentID: [],

      shiptypenamepdf: "",
      shipnamepdf: "",
      ownerpdf: "",
      imonopdf: "",
      letters: "",
      grosstonnagepdf: "",
      flagpdf: "",

      locationpdf: "",
      arrivalpdf: "",
      departurepdf: "",
      lastportpdf: "",
      nextcountrypdf: "",
      nextdeliverypdf: "",
      lastdeliverypdf: "",

      submitpersonpdf: "",

      scalepdf: "",

      oiltanker: "",
      chemicaltanker: "",
      bulkcarrier: "",
      container: "",
      othercargoship: "",
      passenger: "",
      roro: "",
      other: "",

      aa: "",
      aaa: "",
      aremark: "",
      bb: "",
      bbb: "",
      bremark: "",
      cc: "",
      ccc: "",
      cremark: "",
      dd: "",
      ddd: "",
      dremark: "",
      ee: "",
      eee: "",
      eremark: "",
      ff: "",
      fff: "",
      fremark: "",
      aastorage: "",
      bbstorage: "",
      ccstorage: "",
      ddstorage: "",
      eestorage: "",
      ffstorage: "",
      aaretain: "",
      bbretain: "",
      ccretain: "",
      ddretain: "",
      eeretain: "",
      ffretain: "",
      ffspecify: "",

      sewage: "",
      sewageremark: "",
      sewagestorage: "",
      sewageretain: "",

      a: "",
      b: "",
      c: "",
      d: "",
      e: "",
      f: "",
      fspecify: "",
      g: "",
      gremark: "",
      gspecify: "",
      h: "",
      hremark: "",
      i: "",
      iremark: "",

      ozone: "",
      ozonestorage: "",
      ozoneretain: "",
      ozoneremark: "",

      exhaust: "",
      exhauststorage: "",
      exhaustretain: "",
      exhaustremark: "",

      xpdf: "",
      xxpdf: "",
      xmaxpdf: "",
      xretainpdf: "",
      xspdf: "",
      xspecify: "",
      ypdf: "",
      yypdf: "",
      ymaxpdf: "",
      yretainpdf: "",
      yspecify: "",
      otherspecify: "",
      zpdf: "",
      zzpdf: "",
      zmaxpdf: "",
      zretainpdf: "",
      zspecify: "",
      ospdf: "",
      osspdf: "",
      ospecify: "",

      //pdf
      companynamepdf: "XXX Berhad",
      refno: "NPX1234",
      date: moment().format("DD-MM-YYYY"),
      currentpage: "",
      totalpage: "",
      companyaddresspdf:
        "cyberjaya cyberjaya cyberjaya cyberjaya cyberjaya cyberjaya cyberjaya",
      companyphonenopdf: "+6031761606",
      companyemailpdf: "xxx@gmail.com",
      attention: "Mr. XXX",
      subject: "Quotation for Scheduled Waste for PRF",

      deliverypdf: "7",
      paymentpdf: "30",
      validitypdf: "30",
      remarkspdf:
        "Quotation for Scheduled Waste for PRF Quotation for Scheduled Waste for PRF Quotation for Scheduled Waste for PRF Quotation for Scheduled Waste for PRF Quotation for Scheduled Waste for PRF Quotation for Scheduled Waste for PRF",

      pic1pdf: "",
      pic1nopdf: "",
      pic2pdf: "",
      pic2nopdf: "",
    };
  },
  watch: {
    'scope.row.wastetype'(newValue) {
      this.selectedfirst = this.selects.wastetypes.findIndex(
        (option) => option.value === newValue
      );
    },
    "selects.pic"() {
      for (var i = 0; i < this.selects.pics.length; i++) {
        if (this.selects.pic == this.selects.pics[i].value) {
          this.phoneno = this.selects.pics[i].phoneno;
          this.faxno = this.selects.pics[i].faxno;
          this.email = this.selects.pics[i].email;
        }
      }
    },
    submit() {
      console.log(this.submit);
    },
    "selects.location"() {
      console.log(this.selects.location);
      this.getAnakToServiceLocation();
    },
    tableDatas: {
      handler(val, oldVal) {
        for (var i = 0; i < this.tableDatas.length; i++) {
          console.log(this.tableDatas[i].wastetype);
          for (var j = 0; j < this.selects.wastetypes.length; j++) {
            console.log(this.selects.wastetypes[j].value);
            if (
              this.tableDatas[i].wastetype == this.selects.wastetypes[j].value
            ) {
              console.log("sama");
              console.log(this.selects.wastetypes[j].swcodes);
              this.tableDatas[i].wastesubtypes =
                this.selects.wastetypes[j].swcodes;
            }
          }
        }
        console.log(this.tableDatas);
      },
      deep: true,
    },
  },
  created() {
    this.nextTab();

    this.jobno = this.$route.params.jobnum;
    console.log(sessionStorage.getItem("datasubmitted"));
    this.getWasteType();
    // setTimeout(() => {
    //   this.getWasteSubType();
    // }, 500);
    this.submitted = this.$route.params.action;
    // commented soon
    // this.submit = true;
    console.log("is data submit?", this.submitted);

    if (this.submitted == "view" || this.submitted == "edit") {
      this.getSubmittedData();
    }

    this.getDatas();
    this.getLocation();
    this.getPIC();

    this.getPackaging();
    this.getPDF();
    this.getShip();
  },
  mounted() {
    if (this.submitted == "view") {
      this.getPDF();
    }
  },
  computed: {
    dynamicHeight() {
      return this.msdsopen ? "400px" : "120px";
    },
    candone() {
            return this.allmaterialname.length === 0 || this.allstowagename.length === 0;
        },
  },
  methods: {
    openmsds() {
      console.log("okay ke?");

      this.msdsopen = !this.msdsopen;
    },
    openstowage() {
      console.log("okay ke?");

      this.stowageopen = !this.stowageopen;
    },
    openother() {
      console.log("okay ke?");

      this.otheropen = !this.otheropen;
    },
    openquo() {
      console.log("okay ke?");

      this.quoopen = !this.quoopen;
    },
    getShip() {
      this.selects.ships = [];

      this.$http.get(":10001/api/v1/self/ship").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].ship_name,
              value: response[i].ship_id,
            };
            this.selects.ships.push(obj);
          }
        }
      });
    },
    handleFocus(row) {
      row.buttonadd = true; // Set buttonadd to true on focus
      this.warning = true;
      console.log('warning', this.warning);
    },
    checkArrival(value) {
      this.departureOptions.disabledDate = (time) => {
        return value ? time.getTime() < new Date(value).getTime() : false;
      };
    },
    removeStowage(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/incoming/" + this.jobno + "/stowage-plan/" + id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.removeModal = true;
                setTimeout(() => {
                  this.getSubmittedData();
                }, 1000);
              }
            });
        }
      });
    },
    removeMaterial(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/incoming/" +
                this.jobno +
                "/material-safety-data-sheet/" +
                id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.removeModal = true;
                setTimeout(() => {
                  this.getSubmittedData();
                }, 1000);
              }
            });
        }
      });
    },
    redirect() {
      this.$router.push("/Vessel/Request");
    },
    getAnakToServiceLocation() {
      this.selects.collections = [];
      this.selects.collection = "";
      this.$http
        .get(
          ":10001/api/v1/reference/service-location/" + this.selects.location
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            for (var i = 0; i < response.length; i++) {
              let obj = {
                label: response[i].Name,
                value: response[i].ServiceLocationCollectionId,
              };
              this.selects.collections.push(obj);
            }

            // this.selects.collection = this.selects.collections[0].value;
          }
        });
    },
    handleSpecify(name, row) {
      this.warning = true;
    
      console.log(name);
      let obj = {
        name,
        waste_type_sub_id: row.swcode,
      };

      console.log("waste type", obj);

      this.$http
        .post(":10001/api/v1/self/waste-type/" + row.wastetype, obj)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log("jadiii", response.waste_type_sub_id);

            row.newwastetypeid = response.waste_type_sub_id;

            console.log("jadi lagi sekali", row.newwastetypeid);
            // console.log("jadi lagi sekali", response.waste_type_sub_id);

            this.warning = false;
            //buang button
            row.buttonadd = false;
          } else {
            console.log("xjadi");
          }
        });
      this.warning = false;
    },

    getPDF() {
      this.$http
        .get(":10001/api/v1/incoming/" + this.jobno + "/anf")
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            console.log("hui", response);

            this.shiptypenamepdf = response.ship_type_name;
            this.shipnamepdf = response.ship_name;
            this.ownerpdf = response.operator_name;
            this.imonopdf = response.imo_number;
            // this.letters =
            this.grosstonnagepdf = response.gross_tonnage;
            this.flagpdf = response.flag_country_name;

            this.locationpdf = response.service_location;
            this.arrivalpdf = moment(response.arrival_eta).format("DD-MM-YYYY");
            this.departurepdf = moment(response.departure_eta).format(
              "DD-MM-YYYY"
            );
            this.lastportpdf = response.last_port;
            this.lastdatepdf = moment(response.last_port_date).format(
              "DD-MM-YYYY"
            );
            this.nextcountrypdf = response.next_port;
            this.nextdeliverypdf = response.next_port;
            this.lastdeliverypdf = response.previous_port;
            this.submitpersonpdf = response.customer_name;

            if (response.ship_type_name === "Oil Tanker") {
              this.oiltanker = "/";
            } else if (response.ship_type_name === "Chemical Tanker") {
              this.chemicaltanker = "/";
            } else if (response.ship_type_name === "Bulk Carrier") {
              this.bulkcarrier = "/";
            } else if (response.ship_type_name === "Container") {
              this.container = "/";
            } else if (response.ship_type_name === "Other Cargo Ship") {
              this.othercargoship = "/";
            } else if (response.ship_type_name === "Passenger Ship") {
              this.passenger = "/";
            } else if (response.ship_type_name === "Ro-ro") {
              this.roro = "/";
            } else {
              this.other = "/";
            }

            for (let i = 0; i < response.waste_detail.length; i++) {
              //dah okay
              if (
                response.waste_detail[i].waste_type_name === "Annex I - Oil"
              ) {
                const subTypeMap = {
                  "Oily bilge water": "aa",
                  "Oily residues (sludge)": "bb",
                  "Oily tank washings": "cc",
                  "Dirty ballast water": "dd",
                  "Scale and sludge from tank cleaning": "ee",
                  "Other (specify)": "ff",
                };

                const subTypeMap1 = {
                  "Oily bilge water": "aastorage",
                  "Oily residues (sludge)": "bbstorage",
                  "Oily tank washings": "ccstorage",
                  "Dirty ballast water": "ddstorage",
                  "Scale and sludge from tank cleaning": "eestorage",
                  "Other (specify)": "ffstorage",
                };

                const subTypeMap2 = {
                  "Oily bilge water": "aaretain",
                  "Oily residues (sludge)": "bbretain",
                  "Oily tank washings": "ccretain",
                  "Dirty ballast water": "ddretain",
                  "Scale and sludge from tank cleaning": "eeretain",
                  "Other (specify)": "ffretain",
                };

                const subTypeName =
                  response.waste_detail[i].waste_sub_type.sub_type_name;
                const variableName = subTypeMap[subTypeName];
                const variableName1 = subTypeMap1[subTypeName];
                const variableName2 = subTypeMap2[subTypeName];
                // if (variableName) {
                // this[variableName] =
                //   response.waste_detail[i].waste_sub_type.estimated_quantity;

                if (subTypeName === "Oily bilge water") {
                  if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "CBM"
                  ) {
                    this.aa =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  } else if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "MT"
                  ) {
                    this.aaa =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  }
                }

                if (subTypeName === "Oily residues (sludge)") {
                  if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "CBM"
                  ) {
                    this.bb =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  } else if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "MT"
                  ) {
                    this.bbb =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  }
                }

                if (subTypeName === "Oily tank washings") {
                  if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "CBM"
                  ) {
                    this.cc =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  } else if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "MT"
                  ) {
                    this.ccc =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  }
                }

                if (subTypeName === "Dirty ballast water") {
                  if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "CBM"
                  ) {
                    this.dd =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  } else if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "MT"
                  ) {
                    this.ddd =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  }
                }

                if (subTypeName === "Scale and sludge from tank cleaning") {
                  if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "CBM"
                  ) {
                    this.ee =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  } else if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "MT"
                  ) {
                    this.eee =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  }
                }

                if (subTypeName.includes("specify")) {
                  this.ffspecify =
                    response.waste_detail[i].waste_sub_type.specify_name;

                  if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "CBM"
                  ) {
                    this.ff =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  } else if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "MT"
                  ) {
                    this.fff =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  }

                  this.ffstorage =
                    response.waste_detail[
                      i
                    ].waste_sub_type.dedicated_storage_capacity;

                  this.ffretain =
                    response.waste_detail[
                      i
                    ].waste_sub_type.waste_retained_onboard;
                }
                // }

                if (variableName1) {
                  this[variableName1] =
                    response.waste_detail[
                      i
                    ].waste_sub_type.dedicated_storage_capacity;
                }

                if (variableName2) {
                  this[variableName2] =
                    response.waste_detail[
                      i
                    ].waste_sub_type.waste_retained_onboard;
                }
              }
              // }

              //belum okay
              if (
                response.waste_detail[i].waste_type_name == "Annex II - NLS"
              ) {
                // const subTypeMap = {
                //   "Category X substance (specify)": "xpdf",
                //   "Category Y substance (specify)": "ypdf",
                //   "Category Z substance (specify)": "zpdf",
                //   "Other substances (specify)": "ospdf",
                // };

                // for (
                //   let j = 0;
                //   j < response.waste_detail[i].waste_sub_type.length;
                //   j++
                // ) {
                const subTypeName =
                  response.waste_detail[i].waste_sub_type.sub_type_name;
                // const quantity =
                //   response.waste_detail[i].waste_sub_type
                //     .estimated_quantity;

                // if (subTypeMap.hasOwnProperty(subTypeName)) {
                //   this[subTypeMap[subTypeName]] = quantity;
                // }

                if (subTypeName === "Category X substance") {
                  // this.xspecify =
                  //   response.waste_detail[i].waste_sub_type.specify_name;

                  if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "CBM"
                  ) {
                    this.xpdf =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  } else if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "MT"
                  ) {
                    this.xxpdf =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  }

                  this.xmaxpdf =
                    response.waste_detail[
                      i
                    ].waste_sub_type.dedicated_storage_capacity;

                  this.xretainpdf =
                    response.waste_detail[
                      i
                    ].waste_sub_type.waste_retained_onboard;
                }

                if (subTypeName.includes("Category Y substance")) {
                  // this.yspecify =
                  //   response.waste_detail[i].waste_sub_type.specify_name;

                  if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "CBM"
                  ) {
                    this.ypdf =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  } else if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "MT"
                  ) {
                    this.yypdf =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  }

                  this.ymaxpdf =
                    response.waste_detail[
                      i
                    ].waste_sub_type.dedicated_storage_capacity;

                  this.yretainpdf =
                    response.waste_detail[
                      i
                    ].waste_sub_type.waste_retained_onboard;
                }

                if (subTypeName.includes("Category Z substance")) {
                  // this.zspecify =
                  //   response.waste_detail[i].waste_sub_type.specify_name;

                  if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "CBM"
                  ) {
                    this.zpdf =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  } else if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "MT"
                  ) {
                    this.zzpdf =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  }

                  this.zmaxpdf =
                    response.waste_detail[
                      i
                    ].waste_sub_type.dedicated_storage_capacity;

                  this.zretainpdf =
                    response.waste_detail[
                      i
                    ].waste_sub_type.waste_retained_onboard;
                }

                if (subTypeName.includes("Other substances")) {
                  // this.ospecify =
                  //   response.waste_detail[i].waste_sub_type.specify_name;

                  if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "CBM"
                  ) {
                    this.ospdf =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  } else if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "MT"
                  ) {
                    this.osspdf =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  }
                }
              }

              //dah okay
              if (
                response.waste_detail[i].waste_type_name == "Annex IV - Sewage"
              ) {
                if (
                  response.waste_detail[i].waste_sub_type.sub_type_name ==
                  "Untreated/Partially treated"
                ) {
                  this.sewage =
                    response.waste_detail[i].waste_sub_type.estimated_quantity;

                  this.sewageremark =
                    response.waste_detail[i].waste_sub_type.remark;

                  this.sewagestorage =
                    response.waste_detail[
                      i
                    ].waste_sub_type.dedicated_storage_capacity;

                  this.sewageretain =
                    response.waste_detail[
                      i
                    ].waste_sub_type.waste_retained_onboard;
                }
              }

              //dah okay
              if (
                response.waste_detail[i].waste_type_name === "Annex V - Garbage"
              ) {
                // const subTypeMap = {
                //   "Plastics": "a",
                //   "Food wastes": "b",
                //   "Domestic wastes": "c",
                //   "Cooking oil": "d",
                //   "Incinerator ashes": "e",
                //   "Operational wastes (specify)": "f",
                //   "Cargo residues (specify)": "g",
                //   "Animal carcass(es)": "h",
                //   "Fishing gear": "i",
                // };

                // for (
                //   let j = 0;
                //   j < response.waste_detail[i].waste_sub_type.length;
                //   j++
                // ) {
                const subTypeName =
                  response.waste_detail[i].waste_sub_type.sub_type_name;
                // const variableName = subTypeMap[subTypeName];

                // console.log('subtype', subTypeName);

                if (subTypeName === "Plastics") {
                  if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "CBM"
                  ) {
                    this.a =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  } else if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "MT"
                  ) {
                    this.aremark =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  }
                  // this.a =
                  //   response.waste_detail[i].waste_sub_type.estimated_quantity;
                  // this.aremark = response.waste_detail[i].waste_sub_type.estimated_quantity;
                } else if (subTypeName === "Food wastes") {
                  if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "CBM"
                  ) {
                    this.b =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  } else if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "MT"
                  ) {
                    this.bremark =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  }
                  // this.b =
                  //   response.waste_detail[i].waste_sub_type.estimated_quantity;
                  // this.bremark = response.waste_detail[i].waste_sub_type.estimated_quantity;
                } else if (subTypeName.includes("Domestic waste")) {
                  if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "CBM"
                  ) {
                    this.c =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  } else if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "MT"
                  ) {
                    this.cremark =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  }
                  // this.c =
                  //   response.waste_detail[i].waste_sub_type.estimated_quantity;
                  // this.cremark = response.waste_detail[i].waste_sub_type.estimated_quantity;
                } else if (subTypeName === "Cooking oil") {
                  if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "CBM"
                  ) {
                    this.d =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  } else if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "MT"
                  ) {
                    this.dremark =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  }
                  // this.d =
                  //   response.waste_detail[i].waste_sub_type.estimated_quantity;
                  // this.dremark = response.waste_detail[i].waste_sub_type.estimated_quantity;
                } else if (subTypeName === "Incinerator ashes") {
                  if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "CBM"
                  ) {
                    this.e =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  } else if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "MT"
                  ) {
                    this.eremark =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  }
                  // this.e =
                  //   response.waste_detail[i].waste_sub_type.estimated_quantity;
                  // this.eremark = response.waste_detail[i].waste_sub_type.estimated_quantity;
                } else if (subTypeName === "Operational wastes") {
                  if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "CBM"
                  ) {
                    this.f =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  } else if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "MT"
                  ) {
                    this.fremark =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  }
                  // this.f =
                  //   response.waste_detail[i].waste_sub_type.estimated_quantity;
                  // this.fremark = response.waste_detail[i].waste_sub_type.estimated_quantity;
                } else if (subTypeName === "Cargo residues²") {
                  if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "CBM"
                  ) {
                    this.g =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  } else if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "MT"
                  ) {
                    this.gremark =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  }
                  // this.g =
                  //   response.waste_detail[i].waste_sub_type.estimated_quantity;
                  // this.gremark = response.waste_detail[i].waste_sub_type.estimated_quantity;
                } else if (subTypeName === "Animal carcass(es)") {
                  if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "CBM"
                  ) {
                    this.h =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  } else if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "MT"
                  ) {
                    this.hremark =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  }
                  // this.h =
                  //   response.waste_detail[i].waste_sub_type.estimated_quantity;
                  // this.hremark = response.waste_detail[i].waste_sub_type.estimated_quantity;
                }
                // else if (subTypeName === "Others") {
                //   this.i =
                //     response.waste_detail[i].waste_sub_type.estimated_quantity;
                //   this.iremark = response.waste_detail[i].waste_sub_type.remark;
                // }
                else {
                  if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "CBM"
                  ) {
                    this.i =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  } else if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "MT"
                  ) {
                    this.iremark =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  }
                  this.otherspecify =
                    response.waste_detail[i].waste_sub_type.specify_name;
                }

                // if (variableName) {
                //   this[variableName] =
                //     response.waste_detail[i].waste_sub_type.estimated_quantity;
                //     this.aremark = response.waste_detail[i].waste_sub_type.remark;
                // }
                // if (subTypeName === "Operational wastes (specify)") {
                //   this.fspecify =
                //     response.waste_detail[i].waste_sub_type.specify_name;
                // }

                // if (subTypeName === "Cargo residues (specify)") {
                //   this.gspecify =
                //     response.waste_detail[i].waste_sub_type.specify_name;
                // }

                // }
              }

              //dah okay
              if (
                response.waste_detail[i].waste_type_name ===
                "Annex VI - Air Pollution"
              ) {
                const subTypeMap = {
                  "Ozone depleting substances and equipment containing such substances":
                    "ozone",
                  "Exhaust cleaning residues": "exhaust",
                };

                const subTypeMap1 = {
                  "Ozone depleting substances and equipment containing such substances":
                    "ozonestorage",
                  "Exhaust cleaning residues": "exhauststorage",
                };

                const subTypeMap2 = {
                  "Ozone depleting substances and equipment containing such substances":
                    "ozoneretain",
                  "Exhaust cleaning residues": "exhaustretain",
                };

                // for (
                //   let j = 0;
                //   j < response.waste_detail[i].waste_sub_type.length;
                //   j++
                // ) {
                const subTypeName =
                  response.waste_detail[i].waste_sub_type.sub_type_name;

                if (
                  subTypeName ===
                  "Ozone depleting substances and equipment containing such substances"
                ) {
                  // this.a = response.waste_detail[i].waste_sub_type.estimated_quantity;
                  if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "CBM"
                  ) {
                    this.ozone =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  } else if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "MT"
                  ) {
                    this.ozoneremark =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  }
                  // this.ozoneremark =
                  //   response.waste_detail[i].waste_sub_type.estimated_quantity;
                }

                if (subTypeName === "Exhaust cleaning residues") {
                  // this.b = response.waste_detail[i].waste_sub_type.estimated_quantity;
                  if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "CBM"
                  ) {
                    //kena adjust
                    this.exhaust =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  } else if (
                    response.waste_detail[i].waste_sub_type
                      .estimated_quantity_unit == "MT"
                  ) {
                    this.exhaustremark =
                      response.waste_detail[
                        i
                      ].waste_sub_type.estimated_quantity;
                  }
                }

                const variableName = subTypeMap[subTypeName];
                const variableName1 = subTypeMap1[subTypeName];
                const variableName2 = subTypeMap2[subTypeName];

                if (variableName) {
                  this[variableName] =
                    response.waste_detail[i].waste_sub_type.estimated_quantity;
                }

                if (variableName1) {
                  this[variableName1] =
                    response.waste_detail[
                      i
                    ].waste_sub_type.dedicated_storage_capacity;
                }

                if (variableName2) {
                  this[variableName2] =
                    response.waste_detail[
                      i
                    ].waste_sub_type.waste_retained_onboard;
                }
              }
            }
          }
        });
    },
    // createPDF() {
    //   var doc = new jsPDF();
    //   const data = [
    //     {
    //       num1: "1.1 Name of ship:",
    //       desc1: this.shipnamepdf,
    //       num2: "1.5 Owner or operator:",
    //       desc2: this.ownerpdf,
    //     },
    //     {
    //       num1: "1.2 IMO number:",
    //       desc1: this.imonopdf,
    //       num2: "1.5 Distinctive number of letters:",
    //       desc2: this.letters,
    //     },
    //     {
    //       num1: "1.3 Gross Tonnage:",
    //       desc1: this.grosstonnagepdf,
    //       num2: "1.7 Flag State:",
    //       desc2: this.flagpdf,
    //     },
    //     {
    //       num1: "1.4 Type of ship:",
    //       desc1: "Oil Tanker",
    //       num2: "Chemical Tanker",
    //       desc2: "Bulk Carrier",
    //     },
    //     {
    //       num1: "",
    //       desc1: "Container",
    //       num2: "Other cargo ship",
    //       desc2: "Passenger ship",
    //     },
    //     {
    //       num1: "",
    //       desc1: "Ro-ro",
    //       num2: "Other (specify):",
    //       desc2: this.specifypdf,
    //     },
    //   ];
    //   const rows = data.map((obj) => [
    //     obj.num1,
    //     obj.desc1,
    //     obj.num2,
    //     obj.desc2,
    //   ]);

    //   const data2 = [
    //     {
    //       num1: "2.1 Location/Terminal name and POC:",
    //       desc1: this.locationpdf,
    //       num2: "2.6 Last Port where wastes/residues were delivered:",
    //       desc2: this.lastportpdf,
    //     },
    //     {
    //       num1: "2.2 Arrival Date and Time:",
    //       desc1: this.arrivalpdf,
    //       num2: "2.7 Date of Last Delivery:",
    //       desc2: this.lastdeliverypdf,
    //     },
    //     {
    //       num1: "2.3 Departure Date and Time:",
    //       desc1: this.departurepdf,
    //       num2: "2.8 Next Port of Delivery (if known):",
    //       desc2: this.nextdeliverypdf,
    //     },
    //     {
    //       num1: "2.4 Last Port and Country:",
    //       desc1: this.lastportpdf,
    //       num2: "2.9 Person submitting this form is (if other than the master):",
    //       desc2: this.submitpersonpdf,
    //     },
    //     {
    //       num1: "2.5 Next Port and Country (if known):",
    //       desc1: this.nextcountrypdf,
    //       num2: "",
    //       desc2: "",
    //     },
    //   ];
    //   const rows2 = data2.map((obj) => [
    //     obj.num1,
    //     obj.desc1,
    //     obj.num2,
    //     obj.desc2,
    //   ]);

    //   const data3 = [
    //     {
    //       num1: "MARPOL Annex I - Oil",
    //       desc1: "Quantity (M³)",
    //       num2: "MARPOL Annex V - Garbage",
    //       desc2: "Quantity (M³)",
    //     },
    //     {
    //       num1: "Oily bilge water",
    //       desc1: this.aa,
    //       num2: "A. Plastics",
    //       desc2: this.a,
    //     },
    //     {
    //       num1: "Oil residues (sludge)",
    //       desc1: this.bb,
    //       num2: "B. Food wastes",
    //       desc2: this.b,
    //     },
    //     {
    //       num1: "Oily tank washings",
    //       desc1: this.cc,
    //       num2: "C. Domestic wastes",
    //       desc2: this.c,
    //     },
    //     {
    //       num1: "Dirty ballast water",
    //       desc1: this.dd,
    //       num2: "D. Cooking oil",
    //       desc2: this.d,
    //     },
    //     {
    //       num1: "Scale and sludge from tank cleaning",
    //       desc1: this.ee,
    //       num2: "E. Incinerator ashes",
    //       desc2: this.e,
    //     },
    //     {
    //       num1: "Other (please specify): " + this.ffspecify,
    //       desc1: this.ff,
    //       num2: "F. Operational wastes (specify): " + this.fspecify,
    //       desc2: this.f,
    //     },
    //     {
    //       num1: "MARPOL Annex II - NLS",
    //       desc1: "Quantity (M³) / Name",
    //       num2: "G. Cargo residues (specify): " + this.gspecify,
    //       desc2: this.g,
    //     },
    //     {
    //       num1: "Category X substance (specify): " + this.xspecify,
    //       desc1: this.xpdf,
    //       num2: "H. Animal carcass(es)",
    //       desc2: this.h,
    //     },
    //     {
    //       num1: "Category Y substance (specify): " + this.yspecify,
    //       desc1: this.ypdf,
    //       num2: "I. Fishing gear",
    //       desc2: this.i,
    //     },
    //     {
    //       num1: "Category Z substance (specify): " + this.zspecify,
    //       desc1: this.zpdf,
    //       num2: "MARPOL Annex VI - Air pollution",
    //       desc2: "Quantity (M³)",
    //     },
    //     {
    //       num1: "OS - other substance (specify): " + this.ospecify,
    //       desc1: this.ospdf,
    //       num2: "Ozone-depleting substances and equipment containing such substances",
    //       desc2: this.ozone,
    //     },
    //     {
    //       num1: "MARPOL Annex IV - Sewage",
    //       desc1: "Quantity (M³)",
    //       num2: "Exhaust gas-cleaning residues",
    //       desc2: this.exhaust,
    //     },
    //     {
    //       num1: "Untreated/Partially treated",
    //       desc1: this.sewage,
    //       num2: "",
    //       desc2: "",
    //     },
    //   ];
    //   const rows3 = data3.map((obj) => [
    //     obj.num1,
    //     obj.desc1,
    //     obj.num2,
    //     obj.desc2,
    //   ]);

    //   doc.setFontSize(10);
    //   doc.text(
    //     "STANDARD FORMAT OF THE ADVANCE NOTIFICATION FORM FOR WASTE DELIVERY TO PORT",
    //     25,
    //     20
    //   );
    //   doc.text("RECEPTION FACILITIES", 80, 25);

    //   doc.text(
    //     "Notification of the Delivery of Wastes/Residues to:" +
    //     this.locationpdf +
    //     "(enter name of port or terminal). The master of a ",
    //     15,
    //     35
    //   );
    //   doc.text(
    //     "ship should forward the information below to the designated authority at least 24 hours in advance of arrival or ",
    //     15,
    //     40
    //   );
    //   doc.text(
    //     "upon departure of the previous port if the voyage is less than 24 hours.",
    //     15,
    //     45
    //   );
    //   doc.text(
    //     "This form should be retained on board the ship along with the appropriate Oil Record Book, Cargo Record Book ",
    //     15,
    //     55
    //   );
    //   doc.text("or Garbage Record Book.", 15, 60);

    //   doc.text("DELIVERY FROM SHIPS (ANF)", 80, 70);

    //   let startY1 = 80;

    //   doc.text("1.", 15, startY1);
    //   doc.text("SHIP PARTICULARS", 35, startY1);
    //   doc.autoTable({
    //     body: rows,
    //     startY: startY1 + 10,

    //     columnStyles: {
    //       1: { columnWidth: 50 },
    //       2: { columnWidth: 50 },
    //       3: { columnWidth: 50 },
    //     },

    //     didDrawCell: function (data) {
    //       doc.rect(
    //         data.cell.x,
    //         data.cell.y,
    //         data.cell.width,
    //         data.cell.height,
    //         "S"
    //       );
    //     },
    //   });

    //   let startY2 = doc.autoTable.previous.finalY + 15;

    //   doc.text("2.", 15, startY2);
    //   doc.text("PORT AND VOYAGE PARTICULARS", 35, startY2);
    //   doc.autoTable({
    //     body: rows2,
    //     startY: startY2 + 10,

    //     columnStyles: {
    //       0: { columnWidth: 40 },
    //       1: { columnWidth: 40 },
    //       2: { columnWidth: 40 },
    //       // 3: { columnWidth: 50 },
    //     },

    //     didDrawCell: function (data) {
    //       doc.rect(
    //         data.cell.x,
    //         data.cell.y,
    //         data.cell.width,
    //         data.cell.height,
    //         "S"
    //       );
    //     },
    //   });

    //   doc.addPage();
    //   // let startY3 = startY2 + doc.autoTable.previous.finalY + 15;
    //   let startY3 = 20;

    //   console.log(startY3);
    //   let startY4 = startY2 + doc.autoTable.previous.finalY + 15;

    //   doc.text("3.", 15, startY3);
    //   doc.text(
    //     "TYPE AND AMOUNT OF WASTES/RESIDUES FOR DISCHARGE TO FACILITY",
    //     35,
    //     startY3
    //   );
    //   const columnWidth = [50, 25, 60, 25];
    //   doc.autoTable({
    //     body: rows3,
    //     startY: startY3 + 10,

    //     columnStyles: {
    //       0: { columnWidth: columnWidth[0] },
    //       1: { columnWidth: columnWidth[1] },
    //       2: { columnWidth: columnWidth[2] },
    //       3: { columnWidth: columnWidth[3] },
    //     },

    //     didDrawCell: function (data) {
    //       doc.rect(
    //         data.cell.x,
    //         data.cell.y,
    //         data.cell.width,
    //         data.cell.height,
    //         "S"
    //       );
    //     },
    //   });

    //   doc.addPage();

    //   let startY5 = 20;

    //   const ship = [
    //     {
    //       ship: "Name of ship: " + this.shipnamepdf,
    //       imono: "IMO Number: " + this.imonopdf,
    //     },
    //   ];
    //   const rows4 = ship.map((obj) => [obj.ship, obj.imono]);
    //   doc.autoTable({
    //     body: rows4,
    //     startY: startY5,

    //     didDrawCell: function (data) {
    //       doc.rect(
    //         data.cell.x,
    //         data.cell.y,
    //         data.cell.width,
    //         data.cell.height,
    //         "S"
    //       );
    //     },
    //   });
    //   doc.text(
    //     "Please state below the approximate amount of wastes/residues remaining on board and the percentage of maximum",
    //     15,
    //     startY5 + 15
    //   );
    //   doc.text(
    //     "storage capacity. If delivering all wastes/residues on board at this port please strike through this table and tick the",
    //     15,
    //     startY5 + 20
    //   );
    //   doc.text(
    //     "box below. If delivering some or no waste/residue, please complete all columns.",
    //     15,
    //     startY5 + 25
    //   );
    //   doc.text(
    //     "I co nfirm that I am delivering all the wastes/residues held on board this vessel (as shown above) at this port",
    //     15,
    //     startY5 + 35
    //   );

    //   let startY6 = startY5 + 40;

    //   const ticktable = [
    //     {
    //       type: "Type",
    //       storage: "Maximum dedicated storage capacity (M³)",
    //       retained: "Amount of wastes/residues retained on board (M³)",
    //       remaining:
    //         "Port at which remaining wastes/residues will be delivered (if known)",
    //       generated:
    //         "Estimated amount of wastes/residues to be generated between notification and next port of call (M³)",
    //     },
    //     {
    //       type: "MARPOL Annex I - Oil",
    //       storage: "",
    //       retained: "",
    //       remaining: "",
    //       generated: "",
    //     },
    //     {
    //       type: "Oily bilge water",
    //       storage: this.aastorage,
    //       retained: this.aaretain,
    //       remaining: "",
    //       generated: this.aa,
    //     },
    //     {
    //       type: "Oily residues (sludge)",
    //       storage: this.bbstorage,
    //       retained: this.bbretain,
    //       remaining: "",
    //       generated: this.bb,
    //     },
    //     {
    //       type: "Oily tank washings",
    //       storage: this.ccstorage,
    //       retained: this.ccretain,
    //       remaining: "",
    //       generated: this.cc,
    //     },
    //     {
    //       type: "Dirty ballast water",
    //       storage: this.ddstorage,
    //       retained: this.ddretain,
    //       remaining: "",
    //       generated: this.dd,
    //     },
    //     {
    //       type: "Scale and sludge from tank cleaning",
    //       storage: this.eestorage,
    //       retained: this.eeretain,
    //       remaining: "",
    //       generated: this.ee,
    //     },
    //     {
    //       type: "Other (please specify): " + this.ffspecify,
    //       storage: this.ffstorage,
    //       retained: this.ffretain,
    //       remaining: "",
    //       generated: this.ff,
    //     },
    //     {
    //       type: "MARPOL Annex II - NLS3",
    //       storage: "",
    //       retained: "",
    //       remaining: "",
    //       generated: "",
    //     },
    //     {
    //       type: "Category X substance: " + this.xspecify,
    //       storage: "",
    //       retained: "",
    //       remaining: "",
    //       generated: this.xpdf,
    //     },
    //     {
    //       type: "Category Y substance: " + this.yspecify,
    //       storage: "",
    //       retained: "",
    //       remaining: "",
    //       generated: this.ypdf,
    //     },
    //     {
    //       type: "Category Z substance: " + this.zspecify,
    //       storage: "",
    //       retained: "",
    //       remaining: "",
    //       generated: this.zpdf,
    //     },
    //     {
    //       type: "OS - other substances: " + this.ospecify,
    //       storage: "",
    //       retained: "",
    //       remaining: "",
    //       generated: this.ospdf,
    //     },
    //     {
    //       type: "MARPOL Annex IV - Sewage",
    //       storage: "",
    //       retained: "",
    //       remaining: "",
    //       generated: "",
    //     },
    //     {
    //       type: "Untreated/Partially treated",
    //       storage: this.sewagestorage,
    //       retained: this.sewageretain,
    //       remaining: "",
    //       generated: this.sewage,
    //     },
    //     {
    //       type: "MARPOL Annex V - Garbage",
    //       storage: "",
    //       retained: "",
    //       remaining: "",
    //       generated: "",
    //     },
    //     {
    //       type: "A. Plastics",
    //       storage: "",
    //       retained: "",
    //       remaining: "",
    //       generated: this.a,
    //     },
    //     {
    //       type: "B. Food wastes",
    //       storage: "",
    //       retained: "",
    //       remaining: "",
    //       generated: this.b,
    //     },
    //     {
    //       type: "C. Domestic wastes",
    //       storage: "",
    //       retained: "",
    //       remaining: "",
    //       generated: this.c,
    //     },
    //     {
    //       type: "D. Cooking oil",
    //       storage: "",
    //       retained: "",
    //       remaining: "",
    //       generated: this.d,
    //     },
    //     {
    //       type: "E. Incinerator ashes",
    //       storage: "",
    //       retained: "",
    //       remaining: "",
    //       generated: this.e,
    //     },
    //     {
    //       type: "F. Operational wastes (specify): " + this.fspecify,
    //       storage: "",
    //       retained: "",
    //       remaining: "",
    //       generated: this.f,
    //     },
    //     {
    //       type: "G. Cargo residues (specify): " + this.gspecify,
    //       storage: "",
    //       retained: "",
    //       remaining: "",
    //       generated: this.g,
    //     },
    //     {
    //       type: "H. Animal carcass(es)",
    //       storage: "",
    //       retained: "",
    //       remaining: "",
    //       generated: this.h,
    //     },
    //     {
    //       type: "I. Fishing gear",
    //       storage: "",
    //       retained: "",
    //       remaining: "",
    //       generated: this.i,
    //     },
    //     {
    //       type: "MARPOL Annex VI - Air pollution",
    //       storage: "",
    //       retained: "",
    //       remaining: "",
    //       generated: "",
    //     },
    //     {
    //       type: "Ozone-depleting substances and equipment containing such substances",
    //       storage: this.ozonestorage,
    //       retained: this.ozoneretain,
    //       remaining: "",
    //       generated: this.ozone,
    //     },
    //     {
    //       type: "Exhaust gas-cleaning residues",
    //       storage: this.exhauststorage,
    //       retained: this.exhaustretain,
    //       remaining: "",
    //       generated: this.exhaust,
    //     },
    //   ];
    //   const ticks = ticktable.map((obj) => [
    //     obj.type,
    //     obj.storage,
    //     obj.retained,
    //     obj.remaining,
    //     obj.generated,
    //   ]);
    //   doc.autoTable({
    //     body: ticks,
    //     startY: startY6,
    //     columnStyles: {
    //       0: { columnWidth: 50 },
    //     },

    //     didDrawCell: function (data) {
    //       doc.rect(
    //         data.cell.x,
    //         data.cell.y,
    //         data.cell.width,
    //         data.cell.height,
    //         "S"
    //       );
    //     },

    //     createdHeaderCell: function (cell, data) {
    //       if (data.row.index === 0) {
    //         cell.styles.valign = "middle";
    //         cell.styles.halign = "center";
    //       }
    //     },
    //   });

    //   let startY7 = startY6 + 20;
    //   doc.text("Date: ..................................", 25, startY7 + 15);
    //   doc.text(
    //     "Name and Position: .................................................",
    //     85,
    //     startY7 + 15
    //   );

    //   doc.text("Time: ..................................", 25, startY7 + 25);
    //   doc.text(
    //     "Signature: ................................................................",
    //     85,
    //     startY7 + 25
    //   );

    //   doc.save("Advance Notification Form.pdf");

    //   console.log("pdf created");
    // },
    createPDFnew() {
      var doc = new jsPDF();
      // this.aa = "";
      // this.aaa = "";
      // this.aremark = "";
      // this.bb = "";
      // this.bbb = "";
      // this.bremark = "";
      // this.cc = "";
      // this.ccc = "";
      // this.cremark = "";
      // this.dd = "";
      // this.ddd = "";
      // this.dremark = "";
      // this.ee = "";
      // this.eee = "";
      // this.eremark = "";
      // this.ff = "";
      // this.fff = "";
      // this.fremark = "";

      const data = [
        {
          num1: "1.1",
          desc1: "Name of ship: " + this.shipnamepdf,
          num2: "1.5",
          desc2: "Owner or operator: " + this.ownerpdf,
        },
        {
          num1: "1.2",
          desc1: "IMO number: " + this.imonopdf,
          num2: "1.6",
          desc2: "Distinctive number of letters: " + this.letters,
        },
        {
          num1: "1.3",
          desc1: "Gross Tonnage: " + this.grosstonnagepdf,
          num2: "1.7",
          desc2: "Flag State: " + this.flagpdf,
        },
      ];
      const rows = data.map((obj) => [
        obj.num1,
        obj.desc1,
        obj.num2,
        obj.desc2,
      ]);

      const datas = [
        {
          num1: "1.4",
          desc1: "Type of ship:",
          num2: "Oil Tanker",
          desc2: this.oiltanker,
          num3: "Chemical Tanker",
          desc3: this.chemicaltanker,
          num4: "Bulk Carrier",
          desc4: this.bulkcarrier,
          num5: "Container",
          desc5: this.container,
        },
        {
          num1: "",
          desc1: "",
          num2: "Other cargo ship",
          desc2: this.othercargoship,
          num3: "Passenger ship",
          desc3: this.passenger,
          num4: "Ro-ro",
          desc4: this.roro,
          num5: "Other (specify)",
          desc5: this.other,
        },
      ];
      const rowss = datas.map((obj) => [
        obj.num1,
        obj.desc1,
        obj.num2,
        obj.desc2,
        obj.num3,
        obj.desc3,
        obj.num4,
        obj.desc4,
        obj.num5,
        obj.desc5,
      ]);

      const data2 = [
        {
          num1: "2.1",
          desc1: "Location/Terminal name and POC: " + this.locationpdf,
          num2: "2.6",
          desc2:
            "Last Port where wastes/residues were delivered: " +
            this.lastportpdf,
        },
        {
          num1: "2.2",
          desc1: "Arrival Date and Time: " + this.arrivalpdf,
          num2: "2.7",
          desc2: "Date of Last Delivery: " + this.lastdatepdf,
        },
        {
          num1: "2.3",
          desc1: "Departure Date and Time: " + this.departurepdf,
          num2: "2.8",
          desc2: "Next Port of Delivery (if known): " + this.nextdeliverypdf,
        },
        {
          num1: "2.4",
          desc1: "Last Port and Country: " + this.lastportpdf,
          num2: "2.9",
          desc2:
            "Person submitting this form is (if other than the master): " +
            this.submitpersonpdf,
        },
        {
          num1: "2.5",
          desc1: "Next Port and Country (if known): " + this.nextcountrypdf,
          num2: "",
          desc2: "",
        },
      ];
      const rows2 = data2.map((obj) => [
        obj.num1,
        obj.desc1,
        obj.num2,
        obj.desc2,
      ]);

      const data3 = [
        {
          num1: "MARPOL Annex I - Oil",
          desc1: "Quantity (M³)",
          desc12: "Quantity (MT)",
          // desc12: "Remarks",
          num2: "MARPOL Annex V - Garbage",
          desc2: "Quantity (M³)",
          desc22: "Quantity (MT)",
        },
        {
          num1: "Oily bilge water",
          desc1: this.aa,
          desc12: this.aaa,
          num2: "A. Plastics",
          desc2: this.a,
          desc22: this.aremark,
        },
        {
          num1: "Oil residues (sludge)",
          desc1: this.bb,
          desc12: this.bbb,
          num2: "B. Food wastes",
          desc2: this.b,
          desc22: this.bremark, //remarks
        },
        {
          num1: "Oily tank washings",
          desc1: this.cc,
          desc12: this.ccc,
          num2: "C. Domestic wastes (e.g. paper products, rags, glass, metal, bottles, crockery, etc.)",
          desc2: this.c,
          desc22: this.cremark, //remarks
        },
        {
          num1: "Dirty ballast water",
          desc1: this.dd,
          desc12: this.ddd,
          num2: "D. Cooking oil",
          desc2: this.d,
          desc22: this.dremark, //remarks
        },
        {
          num1: "Scale and sludge from tank cleaning",
          desc1: this.ee,
          desc12: this.eee,
          num2: "E. Incinerator ashes",
          desc2: this.e,
          desc22: this.eremark, //remarks
        },
        {
          num1: "Other: " + this.ffspecify,
          desc1: this.ff,
          desc12: this.fff,
          num2: "F. Operational wastes" + this.fspecify,
          desc2: this.f,
          desc22: this.fremark, //remarks
        },
        {
          num1: "MARPOL Annex II - NLS",
          desc1: "",
          desc12: "",
          num2: "G. Cargo residues²" + this.gspecify,
          desc2: this.g,
          desc22: this.gremark,
        },
        {
          num1: "Category X substance",
          // + this.xspecify,
          desc1: this.xpdf,
          desc12: this.xxpdf,
          num2: "H. Animal carcass(es)",
          desc2: this.h,
          desc22: this.hremark,
        },
        {
          num1: "Category Y substance",
          // + this.yspecify,
          desc1: this.ypdf,
          desc12: this.yypdf,
          num2: "I. Others: " + this.otherspecify,
          desc2: this.i,
          desc22: this.iremark,
        },
        // Fluorescent lamp
        {
          num1: "Category Z substance",
          //  + this.zspecify,
          desc1: this.zpdf,
          desc12: this.zzpdf,
          num2: "MARPOL Annex VI - related",
          desc2: "",
        },
        {
          num1: "OS - other substance" + this.ospecify,
          desc1: this.ospdf,
          desc12: this.osspdf,
          num2: "Ozone-depleting substances and equipment containing such substances",
          desc2: this.ozone,
          desc22: "",
          // desc22: this.ozoneremark,
        },
        {
          num1: "MARPOL Annex IV - Sewage",
          desc1: "",
          num2: "Exhaust gas-cleaning residues",
          desc2: this.exhaust,
          desc22: "",
          // desc22: this.exhaustremark,
        },
        {
          num1: "Sewage",
          desc1: this.sewage,
          desc12: "",
          // desc12: this.sewageremark,
          num2: "",
          desc2: "",
        },
      ];
      const rows3 = data3.map((obj) => [
        obj.num1,
        obj.desc1,
        obj.desc12,
        obj.num2,
        obj.desc2,
        obj.desc22,
      ]);

      const logo = new Image();
      logo.src = require("@/assets/img/afesnew.png");
      logo.onload = () => {
        this.options = Object.assign({}, this.options, {
          logo: {
            logo,
          },
        });
      };

      doc.setFontSize(10);
      doc.text("ANF NO: " + this.jobno + "", 150, 5);
      doc.setFontSize(12);

      doc.setFontStyle("bold");
      doc.text("ADVANCE NOTIFICATION FORM (ANF)", 80, 25);
      doc.setFontSize(8);

      doc.addImage(
        logo,
        "PNG",
        doc.internal.pageSize.getWidth() - 200,
        10,
        50,
        18.75
      );

      doc.setLineWidth(0.3); // Set line width
      doc.line(15, 35, doc.internal.pageSize.getWidth() - 10, 35);

      doc.setFontStyle("italic");
      doc.text(
        "This form should be retained on board the vessel along with the appropriate Oil RB, Cargo RB or Garbage RB.",
        15,
        40
      );
      doc.setFontStyle("normal");

      let startY1 = 45;

      doc.setFontSize(9);
      doc.setFontStyle("bold");

      doc.text("1.", 15, startY1);
      doc.text("SHIP PARTICULARS", 25, startY1);

      doc.setFontSize(7);
      doc.setFontStyle("normal");
      const columnWidths = [8, 85, 8, 85];
      const lastRowColumnWidths = [10, 26, 26, 10, 26, 10, 26, 10, 26, 10];
      doc.autoTable({
        body: rows,
        startY: startY1 + 1,
        theme: "plain",

        columnStyles: {
          0: { columnWidth: columnWidths[0], minCellHeight: 0 },
          1: { columnWidth: columnWidths[1] },
          2: { columnWidth: columnWidths[2] },
          3: { columnWidth: columnWidths[3] },
        },
        margin: { top: 0 },
        didDrawCell: function (data) {
          doc.rect(
            data.cell.x,
            data.cell.y,
            data.cell.width,
            data.cell.height,
            "S"
          );
        },

        styles: {
          fontSize: 7,
        },
      });

      const columnWidthss = [8, 30, 29, 8, 29, 8, 29, 8, 29, 8];

      doc.autoTable({
        body: rowss,
        startY: doc.autoTable.previous.finalY,
        theme: "plain",

        columnStyles: {
          0: { columnWidth: columnWidthss[0] },
          1: { columnWidth: columnWidthss[1] },
          2: { columnWidth: columnWidthss[2] },
          3: { columnWidth: columnWidthss[3] },
          4: { columnWidth: columnWidthss[4] },
          5: { columnWidth: columnWidthss[5] },
          6: { columnWidth: columnWidthss[6] },
          7: { columnWidth: columnWidthss[7] },
          8: { columnWidth: columnWidthss[8] },
          9: { columnWidth: columnWidthss[9] },
        },

        didDrawCell: function (data) {
          doc.rect(
            data.cell.x,
            data.cell.y,
            data.cell.width,
            data.cell.height,
            "S"
          );
        },

        styles: {
          fontSize: 7,
        },
      });

      let startY2 = doc.autoTable.previous.finalY + 10;

      doc.setFontSize(9);
      doc.setFontStyle("bold");
      doc.text("2.", 15, startY2);
      doc.text("PORT AND VOYAGE PARTICULARS", 25, startY2);

      doc.setFontSize(7);
      doc.setFontStyle("normal");
      doc.autoTable({
        body: rows2,
        startY: startY2 + 1,
        theme: "plain",

        columnStyles: {
          0: { columnWidth: columnWidths[0] },
          1: { columnWidth: columnWidths[1] },
          2: { columnWidth: columnWidths[2] },
          3: { columnWidth: columnWidths[3] },
        },

        didDrawCell: function (data) {
          doc.rect(
            data.cell.x,
            data.cell.y,
            data.cell.width,
            data.cell.height,
            "S"
          );
        },

        styles: {
          fontSize: 7,
        },
      });

      // doc.addPage();
      let startY3 = doc.autoTable.previous.finalY + 10;
      // let startY3 = 120;

      console.log(startY3);
      let startY4 = startY2 + doc.autoTable.previous.finalY + 10;

      doc.setFontSize(9);
      doc.setFontStyle("bold");
      doc.text("3.", 15, startY3);
      doc.text(
        "TYPE AND AMOUNT OF WASTES/RESIDUES FOR DISCHARGE TO FACILITY",
        25,
        startY3
      );

      const columnWidth = [42, 23, 23, 52, 23, 23];
      doc.autoTable({
        body: rows3,
        startY: startY3 + 1,
        theme: "plain",

        columnStyles: {
          0: { columnWidth: columnWidth[0], halign: "left" },
          1: { columnWidth: columnWidth[1], halign: "center" },
          2: { columnWidth: columnWidth[2], halign: "center" },
          3: { columnWidth: columnWidth[3], halign: "left" },
          4: { columnWidth: columnWidth[4], halign: "center" },
          5: { columnWidth: columnWidth[5], halign: "center" },
        },

        didDrawCell: function (data) {
          doc.rect(
            data.cell.x,
            data.cell.y,
            data.cell.width,
            data.cell.height,
            "S"
          );
        },

        styles: {
          fontSize: 7,
        },
      });

      doc.setFontSize(8);
      doc.setFontStyle("normal");

      // doc.save("Advance Notification Form.pdf");

      // console.log("pdf created");

      doc.addPage();

      doc.setFontSize(10);
      doc.text("ANF NO: " + this.jobno + "", 150, 5);
      doc.setFontSize(8);

      let startY5 = 20;

      const ship = [
        {
          ship: "Name of ship: " + this.shipnamepdf,
          imono: "IMO Number: " + this.imonopdf,
        },
      ];
      const rows4 = ship.map((obj) => [obj.ship, obj.imono]);
      doc.autoTable({
        body: rows4,
        startY: startY5,
        theme: "plain",

        didDrawCell: function (data) {
          doc.rect(
            data.cell.x,
            data.cell.y,
            data.cell.width,
            data.cell.height,
            "S"
          );
        },

        styles: {
          fontSize: 7,
        },
      });
      doc.text(
        "Please state below the approximate amount of wastes/residues remaining on board and the percentage of maximum storage capacity. If delivering",
        15,
        startY5 + 15
      );
      doc.text(
        "all wastes/residues on board at this port please strike through this table and tick the box below. If delivering some or no waste/residues, please",
        15,
        startY5 + 20
      );
      doc.text("complete all columns.", 15, startY5 + 25);
      doc.text(
        "I confirm that I am delivering all the wastes/residues held on board this vessel (as shown above) at this port",
        15,
        startY5 + 35
      );

      let startY6 = startY5 + 40;

      const ticktable = [
        {
          type: "\n\t\t\tType",
          storage: "Maximum dedicated storage capacity (M³)",
          retained: "Amount of wastes/residues retained on board (M³)",
          remaining:
            "Port at which remaining wastes/residues will be delivered (if known)",
          generated:
            "Estimated amount of wastes/residues to be generated between notification and next port of call (M³)",
        },
        {
          type: "MARPOL Annex I - Oil",
          storage: "",
          retained: "",
          remaining: "",
          generated: "",
        },
        {
          type: "Oily bilge water",
          storage: this.aastorage,
          retained: this.aaretain,
          remaining: "",
          generated: this.aa,
        },
        {
          type: "Oily residues (sludge)",
          storage: this.bbstorage,
          retained: this.bbretain,
          remaining: "",
          generated: this.bb,
        },
        {
          type: "Oily tank washings",
          storage: this.ccstorage,
          retained: this.ccretain,
          remaining: "",
          generated: this.cc,
        },
        {
          type: "Dirty ballast water",
          storage: this.ddstorage,
          retained: this.ddretain,
          remaining: "",
          generated: this.dd,
        },
        {
          type: "Scale and sludge from tank cleaning",
          storage: this.eestorage,
          retained: this.eeretain,
          remaining: "",
          generated: this.ee,
        },
        {
          type: "Other (please specify) " + this.ffspecify,
          storage: this.ffstorage,
          retained: this.ffretain,
          remaining: "",
          generated: this.ff,
        },
        {
          type: "MARPOL Annex II - NLS",
          storage: "",
          retained: "",
          remaining: "",
          generated: "",
        },
        {
          type: "Category X substance " + this.xspecify,
          storage: this.xmaxpdf,
          retained: this.xretainpdf,
          remaining: "",
          generated: this.xpdf,
        },
        {
          type: "Category Y substance " + this.yspecify,
          storage: this.ymaxpdf,
          retained: this.yretainpdf,
          remaining: "",
          generated: this.ypdf,
        },
        {
          type: "Category Z substance " + this.zspecify,
          storage: this.zmaxpdf,
          retained: this.zretainpdf,
          remaining: "",
          generated: this.zpdf,
        },
        // {
        //   type: "OS - other substances: " + this.ospecify,
        //   storage: "",
        //   retained: "",
        //   remaining: "",
        //   generated: this.ospdf,
        // },
        {
          type: "MARPOL Annex IV - Sewage",
          storage: "",
          retained: "",
          remaining: "",
          generated: "",
        },
        {
          type: "Sewage",
          storage: this.sewagestorage,
          retained: this.sewageretain,
          remaining: "",
          generated: this.sewage,
        },
        {
          type: "MARPOL Annex V - Garbage",
          storage: "",
          retained: "",
          remaining: "",
          generated: "",
        },
        {
          type: "A. Plastics",
          storage: "",
          retained: "",
          remaining: "",
          generated: this.a,
        },
        {
          type: "B. Food wastes",
          storage: "",
          retained: "",
          remaining: "",
          generated: this.b,
        },
        {
          type: "C. Domestic wastes (e.g. paper producst, rags, glass, metal, bottles, crockery, etc.)",
          storage: "",
          retained: "",
          remaining: "",
          generated: this.c,
        },
        {
          type: "D. Cooking oil",
          storage: "",
          retained: "",
          remaining: "",
          generated: this.d,
        },
        {
          type: "E. Incinerator ashes",
          storage: "",
          retained: "",
          remaining: "",
          generated: this.e,
        },
        {
          type: "F. Operational wastes ",
          storage: "",
          retained: "",
          remaining: "",
          generated: this.f,
        },
        {
          type: "G. Cargo residues² ",
          storage: "",
          retained: "",
          remaining: "",
          generated: this.g,
        },
        {
          type: "H. Animal carcass(es)",
          storage: "",
          retained: "",
          remaining: "",
          generated: this.h,
        },
        {
          type: "I. Others: " + this.otherspecify,
          storage: "",
          retained: "",
          remaining: "",
          generated: this.i,
        },
        {
          type: "MARPOL Annex VI - related",
          storage: "",
          retained: "",
          remaining: "",
          generated: "",
        },
        {
          type: "Ozone-depleting substances and equipment containing such substances",
          storage: this.ozonestorage,
          retained: this.ozoneretain,
          remaining: "",
          generated: this.ozone,
        },
        {
          type: "Exhaust gas-cleaning residues",
          storage: this.exhauststorage,
          retained: this.exhaustretain,
          remaining: "",
          generated: this.exhaust,
        },
      ];
      const ticks = ticktable.map((obj) => [
        obj.type,
        obj.storage,
        obj.retained,
        obj.remaining,
        obj.generated,
      ]);
      doc.autoTable({
        body: ticks,
        startY: startY6,
        theme: "plain",

        columnStyles: {
          0: { halign: "left" }, // First column left-aligned
          1: { halign: "center" },
          2: { halign: "center" },
          3: { halign: "center" },
          4: { halign: "center" },
        },

        didDrawCell: function (data) {
          doc.rect(
            data.cell.x,
            data.cell.y,
            data.cell.width,
            data.cell.height,
            "S"
          );
        },

        // createdHeaderCell: function (cell, data) {
        //   if (data.row.index === 0) {
        //     cell.styles.valign = "middle";
        //     cell.styles.halign = "center";
        //   }
        // },

        styles: {
          fontSize: 7,
          valign: "middle",
          // halign: "center",
        },
      });

      let startY7 = doc.autoTable.previous.finalY + 10;
      // doc.text("Date: ..................................", 25, startY77 + 15);
      // doc.text(
      //   "Name and Position: .................................................",
      //   85,
      //   startY77 + 15
      // );

      // doc.text("Time: ..................................", 25, startY77 + 25);
      // doc.text(
      //   "Signature: ................................................................",
      //   85,
      //   startY77 + 25
      // );

      // let startY7 = startY3 + 105;
      doc.text("Signature", 25, startY7);
      doc.text(":", 45, startY7);
      doc.text("Full Name and Position", 85, startY7);
      doc.text(":", 115, startY7);

      // doc.text("_______________", 25, startY7 + 10 + 22);
      doc.text("Date", 25, startY7 + 10 + 10);
      doc.text(":", 45, startY7 + 10 + 10);
      doc.text("Time", 85, startY7 + 10 + 10);
      doc.text(":", 115, startY7 + 10 + 10);

      doc.text(
        "1   Indicate the proper shipping name of the NLS involved.",
        25,
        startY7 + 10 + 15
      );
      doc.text(
        "2   Indicate the proper shipping name of dry cargo.",
        25,
        startY7 + 10 + 20
      );

      doc.save("Advance Notification Form.pdf");

      console.log("pdf created");
      // },
    },
    edit() {
      this.wastearray = [];
      this.oiltanker = "";
      this.chemicaltanker = "";
      this.bulkcarrier = "";
      this.container = "";
      this.othercargoship = "";
      this.passenger = "";
      this.roro = "";
      this.other = "";
      this.aa = "";
      this.aaa = "";
      this.aremark = "";
      this.bb = "";
      this.bbb = "";
      this.bremark = "";
      this.cc = "";
      this.ccc = "";
      this.cremark = "";
      this.dd = "";
      this.ddd = "";
      this.dremark = "";
      this.ee = "";
      this.eee = "";
      this.eremark = "";
      this.ff = "";
      this.fff = "";
      this.fremark = "";
      this.g = "";
      this.gremark = "";
      this.gspecify = "";
      this.h = "";
      this.hremark = "";
      this.i = "";
      this.iremark = "";

      this.ozone = "";
      this.ozonestorage = "";
      this.ozoneretain = "";
      this.ozoneremark = "";

      this.sewage = "";
      this.sewageremark = "";

      this.exhaust = "";
      this.exhauststorage = "";
      this.exhaustretain = "";
      this.exhaustremark = "";

      this.xpdf = "";
      this.xspdf = "";
      this.xspecify = "";
      this.ypdf = "";
      this.yypdf = "";
      this.yspecify = "";
      this.otherspecify = "";
      this.zpdf = "";
      this.zzpdf = "";
      this.zspecify = "";
      this.ospdf = "";
      this.osspdf = "";
      this.ospecify = "";

      this.submit = false;
    },
    getSubmittedData() {
      this.tableDatas = [];
      this.allfilename = [];
      this.allmaterialname = [];
      this.allstowagename = [];
      this.allquodocname = [];

      this.$http.get(":10001/api/v1/incoming/" + this.jobno).then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          if (response.material_safety_data_sheet.length != 0) {
            this.msds = response.material_safety_data_sheet[0].url;
          }
          if (response.stowage_plan.length != 0) {
            this.stowage = response.stowage_plan[0].url;
          }

          if (response.waste_job_document.length != 0) {
            this.otherdoc = response.waste_job_document[0].url;
          }

          this.arrival = moment(response.arrival_eta).format("YYYY-MM-DD");
          this.arrivaletasubmit = moment(response.arrival_eta).format(
            "YYYY-MM-DD"
          );

          this.departure = moment(response.departure_eta).format("YYYY-MM-DD");
          this.departureetasubmit = moment(response.departure_eta).format(
            "YYYY-MM-DD"
          );

          this.previousport = response.previous_port;
          this.previousportsubmit = response.previous_port;

          this.nextport = response.next_port;
          this.nextportsubmit = response.next_port;

          this.lastport = response.last_port;
          this.lastportsubmit = response.last_port;

          this.lastdate =
            response.last_port_date == ""
              ? "N/A"
              : moment(response.last_port_date).format("YYYY-MM-DD");

          this.lastportdate =
            response.last_port_date == ""
              ? ""
              : moment(response.last_port_date).format("YYYY-MM-DD");

          if (response.ship != null) {
            this.selects.ship = response.ship.ship_id;
            this.shipsubmit = response.ship.ship_name.toString();
          }
          this.servicelocatiobsubmit =
            response.service_location_name.toString();
          this.picsubmit = response.pic.user_name.toString();

          this.selects.location = response.service_location_id;
          setTimeout(() => {
            this.selects.collection = response.service_location_collection_id;
          }, 1000);

          let component = [];
          let comp = "";

          for (var i = 0; i < response.waste_detail.length; i++) {
            console.log(response.waste_detail[i].estimated_quantity);
            let obj = {
              id: "1",
              wastetype: response.waste_detail[i].waste_type_id,

              wastetypename: response.waste_detail[i].waste_type_name,
              swcodename: response.waste_detail[i].waste_type_sub_name,
              swcode: response.waste_detail[i].waste_type_sub_id,

              // wasteorigin: response.waste_detail[i].waste_source,
              estqty: response.waste_detail[i].estimated_quantity,
              wasteqty: response.waste_detail[i].estimated_quantity.toString(),
              wasteqtyunit: response.waste_detail[i].estimated_quantity_unit,

              storage:
                response.waste_detail[i].dedicated_storage_capacity.toString(),
              storageunit:
                response.waste_detail[i].dedicated_storage_capacity_unit,

              retain:
                response.waste_detail[i].waste_retained_onboard.toString(),
              retainunit: response.waste_detail[i].waste_retained_onboard_unit,
              remarks: response.waste_detail[i].remarks,
            };
            this.tableDatas.push(obj);
          }

          // get material safety file
          if (response.material_safety_data_sheet != null) {
            for (
              var i = 0;
              i < response.material_safety_data_sheet.length;
              i++
            ) {
              let obj = {
                filename: response.material_safety_data_sheet[i].meta.filename,
                fileurl: response.material_safety_data_sheet[i].url,
                fileid: response.material_safety_data_sheet[i].msds_id,
              };
              this.allmaterialname.push(obj);
            }
          }

          // get stowage plan
          if (response.stowage_plan != null) {
            for (var i = 0; i < response.stowage_plan.length; i++) {
              let obj = {
                filename: response.stowage_plan[i].meta.filename,
                fileurl: response.stowage_plan[i].url,
                fileid: response.stowage_plan[i].stowage_plan_id,
              };
              this.allstowagename.push(obj);
            }
          }

          if (response.waste_job_document != null) {
            for (var i = 0; i < response.waste_job_document.length; i++) {
              let obj = {
                filename: response.waste_job_document[i].meta.filename,
                fileurl: response.waste_job_document[i].url,
                fileid: response.waste_job_document[i].waste_job_document_id,
              };
              this.allfilename.push(obj);
            }
          }

          //get quo docs
          if (response.quotation != null)
            if (response.quotation.quotation_support_document != null) {
              for (
                var i = 0;
                i < response.quotation.quotation_support_document.length;
                i++
              ) {
                let obj = {
                  filename:
                    response.quotation.quotation_support_document[i].filename,
                  fileurl: response.quotation.quotation_support_document[i].url,
                  fileid:
                    response.quotation.quotation_support_document[i]
                      .quotation_support_document_id,
                };
                this.allquodocname.push(obj);
              }
            }
        }
      });
    },

    getData() {},
    nextTab() {
      // console.log("next page")
      let parameter = {
        step: "1",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
      // this.validateStep('step2')
    },
    async exitTab() {
      this.$router.push("/Vessel/Request");
      // console.log("exit")
      let parameter = {
        step: "1",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },

    submitData() {
      this.modals.submit = true;
      setTimeout(() => {
        this.modals.submit = false;
      }, 1500);

      this.submit = true;
      console.log("jobno", this.jobno);
      this.getPDF();
    },

    getDeleteRow(row) {
      console.log("rowww", row);
      this.tableDatas.splice(row, 1);
    },

    addRow() {
      let obj = {
        id: this.tableDatas.length + 1,
        buttonadd: true,
        wastetype: "",
        swcode: "",
        newwastetypeid: "",
        wasteqty: "",
        storage: "",
        retain: "",
        remarks: "",
      };

      this.tableDatas.push(obj);

      console.log("array here", this.tableDatas);
    },

    onFileChange(event) {
      this.uploadloadrecurring = true;
      const t = event.target;

      if (t.files.length > 0) {
        const filesArray = Array.from(t.files);

        this.selectedFileName = filesArray.map((file) => file.name).join(", ");
        this.document = filesArray.length;

        const uploadPromises = [];

        this.uploadload = true;

        for (let i = 0; i < filesArray.length; i++) {
          const input = filesArray[i];
          const formData = new FormData();
          formData.append("document", input);

          this.buttondisabled = true;

          this.$http
            .post(
              ":10001/api/v1/incoming/" +
                this.jobno +
                "/upload/upload-waste-job",
              formData,
              {
                headers: {
                  Authorization: `Bearer ${getStorage("token")}`,
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                //dapat response deleted tapi skrg tgh upload
                this.modals.successModal = true;
                this.uploadloadrecurring = false;
                this.getSubmittedData();
              } else {
                console.log("data tak masuk");
              }
            });
          this.uploadload = false;
          this.buttondisabled = false;
        }
      }
    },
    //     onFileChange2(event) {
    //       this.uploadloadanf = true;
    //       const t = event.target;
    //       console.log("ref", this.$refs.materialsafety);

    //   if (t.files.length > 0) {
    //     console.log("length :", t.files.length);

    //     const uploadPromises = [];

    //     for (let i = 0; i < t.files.length; i++) {
    //       const input = t.files[i];
    //       const formData = new FormData();
    //       formData.append("document", input);

    //       this.uploadloadstowage = true;
    //       this.buttondisabled = true;

    //           this.$http
    //             .post(
    //               ":10001/api/v1/incoming/" +
    //               this.jobno +
    //               "/material-safety-data-sheet",
    //               docs,
    //               {
    //                 headers: {
    //                   Authorization: "Bearer " + getStorage("token"),
    //                   "Content-Type": "multipart/form-data",
    //                 },
    //               }
    //             )
    //             .then((res) => {
    //               if (!res.error) {
    //                 let response = res.message;
    //                 console.log(response);
    //                 console.log(response);
    //                 this.message = response;
    //                 this.modals.successModal = true;
    //                 this.uploadloadanf = false;

    //                 setTimeout(() => {
    //                   this.getSubmittedData();
    //                 }, 1000);
    //               } else {
    //                 console.log("data tak masuk");
    //               }
    //             });

    //       uploadPromises.push(uploadPromise);
    //     }

    //     Promise.all(uploadPromises).then(() => {
    //       this.modals.successModal = true;
    //       this.buttondisabled = false;
    //       this.uploadloadstowage = false;
    //     }).catch((error) => {
    //       console.error("One or more uploads failed:", error);
    //       this.buttondisabled = false;
    //       this.uploadloadstowage = false;
    //     });
    //   }
    // }
    // ,

    onFileChange2(event) {
      this.uploadloadanf = true;
      const t = event.target;
      console.log("ref", this.$refs.materialsafety);

      if (t.files.length > 0) {
        console.log("length :", t.files.length);
        const uploadPromises = [];

        for (let i = 0; i < t.files.length; i++) {
          const input = this.$refs.materialsafety.files[i];
          const formData = new FormData();
          formData.append("document", input);

          this.uploadloadanf = true;
          this.buttondisabled = true;

          const uploadPromise = this.$http
            .post(
              ":10001/api/v1/incoming/" +
                this.jobno +
                "/material-safety-data-sheet",
              formData,
              {
                headers: {
                  Authorization: "Bearer " + getStorage("token"),
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;

                // this.uploadloadanf = false;

                setTimeout(() => {
                  this.getSubmittedData();
                }, 1000);
              } else {
                console.log("data tak masuk");
              }
            });

          uploadPromises.push(uploadPromise);
        }

        Promise.all(uploadPromises)
          .then(() => {
            this.modals.successModal = true;
            this.buttondisabled = false;
            this.uploadloadanf = false;
            t.value = "";

          })
          .catch((error) => {
            console.error("One or more uploads failed:", error);
            this.buttondisabled = false;
            this.uploadloadanf = false;
          });
      }
    },
    // onFileChange(event) {
    //       this.uploadloadrecurring = true;
    //       const t = event.target;
    //       if (t.files.length > 0) {
    //         for (let i = 0; i < t.files.length; i++) {
    //           this.selectedFileName = t.files[i].name;
    //           // this.allfilename.push(this.selectedFileName);
    //         }
    //       } else {
    //         this.selectedFileName = "";
    //       }

    //       this.document = t.files.length;

    //       var input;
    //       if (t.files.length > 0) {
    //         for (let i = 0; i < t.files.length; i++) {
    //           input = this.$refs.file.files[i];
    //           const formData = new FormData();
    //           formData.append("document", input);
    //           let docs = formData;

    //           this.buttondisabled = true;

    //           this.$http
    //             .post(
    //               ":10001/api/v1/incoming/" +
    //               this.jobno +
    //               "/upload/upload-waste-job",
    //               docs,
    //               {
    //                 headers: {
    //                   Authorization: `Bearer ${getStorage("token")}`,
    //                   "Content-Type": "multipart/form-data",
    //                 },
    //               }
    //             )
    //             .then((res) => {
    //               if (!res.error) {
    //                 let response = res.message;
    //                 console.log(response);
    //                 this.message = response;
    //                 //dapat response deleted tapi skrg tgh upload
    //                 this.modals.successModal = true;
    //                 this.uploadloadrecurring = false;
    //                 this.getSubmittedData();
    //               } else {
    //                 console.log("data tak masuk");
    //               }
    //             });
    //           this.uploadload = false;
    //           this.buttondisabled = false;
    //         }
    //       }
    //     },

    // onFileChange2(event) {
    //   this.uploadloadanf = true;
    //   const t = event.target;
    //   console.log("ref", this.$refs.materialsafety);

    //   var input;
    //   if (t.files.length > 0) {
    //     console.log("length :", t.files.length);
    //     for (let i = 0; i < t.files.length; i++) {
    //       input = this.$refs.materialsafety.files[i];
    //       const formData = new FormData();
    //       formData.append("document", input);
    //       let docs = formData;

    //       this.uploadload = true;
    //       this.buttondisabled = true;

    //       this.$http
    //         .post(
    //           ":10001/api/v1/incoming/" +
    //           this.jobno +
    //           "/material-safety-data-sheet",
    //           docs,
    //           {
    //             headers: {
    //               Authorization: "Bearer " + getStorage("token"),
    //               "Content-Type": "multipart/form-data",
    //             },
    //           }
    //         )
    //         .then((res) => {
    //           if (!res.error) {
    //             let response = res.message;
    //             console.log(response);
    //             console.log(response);
    //             this.message = response;
    //             this.modals.successModal = true;
    //             this.uploadloadanf = false;

    //             setTimeout(() => {
    //               this.getSubmittedData();
    //             }, 1000);
    //           } else {
    //             console.log("data tak masuk");
    //           }
    //         });

    //       this.buttondisabled = false;
    //     }
    //   }
    // },
    onFileChange3(event) {
      this.uploadloadstowage = true;
      const t = event.target;
      console.log("ref", this.$refs.stowageplan);

      var input;
      if (t.files.length > 0) {
        console.log("length :", t.files.length);
        for (let i = 0; i < t.files.length; i++) {
          input = this.$refs.stowageplan.files[i];
          const formData = new FormData();
          formData.append("document", input);
          let docs = formData;

          this.uploadload = true;
          this.buttondisabled = true;

          this.$http
            .post(
              ":10001/api/v1/incoming/" + this.jobno + "/stowage-plan",
              docs,
              {
                headers: {
                  Authorization: "Bearer " + getStorage("token"),
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                //dapat response deleted tapi skrg tgh upload
                this.modals.successModal = true;
                this.uploadloadstowage = false;
                this.getSubmittedData();
              } else {
                console.log("data tak masuk");
              }
            });

          this.buttondisabled = false;
        }
      }
    },
    // removeFile(indexToRemove) {
    //   // let documentremove = this.documentID[indexToRemove];
    //   // console.log("doc remove", documentremove);
    //   // if (indexToRemove >= 0 && indexToRemove < this.allfilename.length) {
    //   //   this.allfilename.splice(indexToRemove, 1);
    //   //   this.documentID.splice(indexToRemove, 1);
    //   // }

    //   this.$http
    //     .delete(
    //       ":10001/api/v1/incoming/" +
    //       this.jobno +
    //       "/upload/upload-waste-job/" +
    //       indexToRemove
    //     )
    //     .then((res) => {
    //       if (!res.error) {
    //         console.log("doc delete");
    //         this.getSubmittedData()
    //       } else {
    //       }
    //     });
    //   this.$emit("change", null);
    // },

    removeFile(id) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/incoming/" +
                this.jobno +
                "/upload/upload-waste-job/" +
                id
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.removeModal = true;
                setTimeout(() => {
                  this.getSubmittedData();
                }, 1000);
              }
            });
        }
      });
    },
    saveDraft() {
      this.wastearray = [];
      this.tableDatas.forEach((data) => {
        this.wastearray.push({
          waste_type: parseInt(data.wastetype),
          waste_sub_type: parseInt(data.swcode),
          // data.swcode === 15 ||
          // data.swcode === 16 ||
          // data.swcode === 17 ||
          // data.swcode === 18 ||
          // data.swcode === 19 ||
          // data.swcode === 26 ||
          // data.swcode === 27
          //   ? data.newwastetypeid
          //   : data.swcode,
          estimate_quantity: parseInt(data.estqty),
          estimate_quantity_unit: "CBM",
          dedicated_storage_capacity: parseInt(data.storage),
          dedicated_storage_capacity_unit: "CBM",
          waste_retained_onboard: parseInt(data.retain),
          waste_retained_onboard_unit: "CBM",
          remarks: data.remarks,
        });
      });

      console.log("waste array", this.wastearray);

      let obj = {
        reference_no: this.jobno,
        arrival_eta: moment(this.arrival).format("YYYY-MM-DD"),
        departure_eta: moment(this.departure).format("YYYY-MM-DD"),
        previous_port: this.previousport,
        next_port: this.nextport,
        last_port: this.lastport,
        last_port_date:
          this.lastportdate == ""
            ? null
            : moment(this.lastportdate).format("YYYY-MM-DD"),
        service_location_id: parseInt(this.selects.location),
        service_location_collection_id:
          this.selects.collection == "" ? null : this.selects.collection,
        pic_id: parseInt(this.selects.pic),
        waste: this.wastearray,
        ship_id: parseInt(this.selects.ship),
      };

      console.log("obj", obj);

      this.$http
        .post(":10001/api/v1/incoming/" + this.jobno + "/draft", obj)
        .then((res) => {
          let response = res.message;

          if (!res.error) {
            console.log("data vessel masuk", response);
            this.submitData();
            this.wastearray = [];
            this.getSubmittedData();
            this.modals.warningsubmit = false;
          } else if (res.error) {
            console.log("data vessel tak masuk");
            this.modals.warningsubmit = false;

            // swal({
            //   title: "Data Error!",
            //   text: `${res.message}`,
            //   type: "warning",
            //   confirmButtonClass: "btn btn-success btn-fill",
            //   confirmButtonText: "Okay",
            //   buttonsStyling: false,
            // });
          }
        })
        .catch((err) => {
          console.log(err.response.data.message);
          this.message = err.response.data.message;
          this.modals.failedModal = true;
        });
    },
    submitJobRequest() {
      this.wastearray = [];
      this.errmsg = "";
      let flag = false;
      this.tableDatas.forEach((data) => {
        console.log(data);
        if (
          // data.wastetype != null &&
          data.wastetype != "" &&
          // data.swcode != null &&
          data.swcode != "" &&
          // data.estqty === null ||
          data.estqty != "" &&
          // data.measurement === null ||
          // data.measurement === "" ||
          // data.storage === null ||
          data.storage != "" &&
          // data.measurement1 === null ||
          // data.measurement1 === "" ||
          // data.retain === null ||
          data.retain != ""
          // data.measurement2 === null ||
          // data.measurement2 === ""
        ) {
          flag = true;
          this.wastearray.push({
            waste_type: parseInt(data.wastetype),
            waste_sub_type: parseInt(data.swcode),

            estimate_quantity: parseInt(data.estqty),
            estimate_quantity_unit: "CBM",
            dedicated_storage_capacity: parseInt(data.storage),
            dedicated_storage_capacity_unit: "CBM",
            waste_retained_onboard: parseInt(data.retain),
            waste_retained_onboard_unit: "CBM",
            remarks: data.remarks,
          });
        } else {
          flag = false;
          this.errmsg = "Please fill in all the required data.";
          // this.modals.warningsubmit = true;
        }
        // console.log(data.swcode)
      });

      if (flag == true) {
        console.log("waste array", this.wastearray);

        let obj = {
          reference_no: this.jobno,
          arrival_eta: moment(this.arrival).format("YYYY-MM-DD"),
          departure_eta: moment(this.departure).format("YYYY-MM-DD"),
          previous_port: this.previousport,
          next_port: this.nextport,
          last_port: this.lastport,
          last_port_date: moment(this.lastportdate).format("YYYY-MM-DD"),
          service_location_id: parseInt(this.selects.location),
          service_location_collection_id:
            this.selects.collection == "" ? 0 : this.selects.collection,
          pic_id: parseInt(this.selects.pic),
          waste: this.wastearray,
          ship_id: parseInt(this.selects.ship),
        };

        console.log("obj", obj);

        this.$http
          .post(":10001/api/v1/incoming/" + this.jobno, obj)
          .then((res) => {
            let response = res.message;

            if (!res.error) {
              console.log("data vessel masuk", response);
              this.submitData();
              this.wastearray = [];
            } else if (res.error) {
              console.log("data vessel tak masuk");
              this.modals.warningsubmit = false;
            }
          })
          .catch((err) => {
            this.message = err.response.data.message;
            this.modals.failedModal = true;
          });
      }
    },
    addWasteComponent(index) {
      this.tableDatas[index].wasteComponents.push({ componentname: "" });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        let style = { background: "#FFFFFF", color: "#15cf79" };
        return style;
      } else {
        let style = { background: "#f5f6fa", color: "#959595" };
        return style;
      }
    },
    getLocation() {
      this.selects.locations = [];
      this.$http.get(":10001/api/v1/reference/service-location").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].Location,
              value: response[i].ServiceLocationId,
            };

            this.selects.locations.push(obj);
          }

          // this.selects.location = this.selects.locations[0].value;
        }
      });
    },
    getPIC() {
      this.selects.pics = [];
      this.picdetail = [];

      this.$http.get(":10001/api/v1/self/pic").then((res) => {
        if (!res.error) {
          let response = res.message;

          console.log("pic", response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].user_name,
              value: response[i].user_id,
              id: response[i].user_id,
              name: response[i].user_name,
              phoneno: response[i].user_phone_number,
              faxno:
                response[i].user_fax_number == ""
                  ? "N/A"
                  : response[i].user_fax_number,
              email: response[i].user_email,
            };

            this.selects.pics.push(obj);

            let obj2 = {
              id: response[i].user_id,
              name: response[i].user_name,
              phoneno: response[i].user_phone_number,
              faxno:
                response[i].user_fax_number == ""
                  ? "N/A"
                  : response[i].user_fax_number,
              email: response[i].user_email,
            };

            this.picdetail.push(obj2);
          }

          this.selects.pic = this.selects.pics[0].value;
        }
      });
    },
    getWasteType() {
      this.selects.wastetypes = [];
      this.$http
        .get(":10001/api/v1/self/waste-type/new?type=vessel")
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            console.log("heree api", response);

            for (var i = 0; i < response.length; i++) {
              let oo = [];
              for (var j = 0; j < response[i].waste_sub_type.length; j++) {
                let pp = {
                  label: response[i].waste_sub_type[j].name,
                  value: response[i].waste_sub_type[j].waste_sub_type_id,
                };
                oo.push(pp);
              }
              let obj = {
                label: response[i].name,
                value: response[i].waste_type_id,
                swcodes: oo,
              };

              this.selects.wastetypes.push(obj);
            }

            // this.tableDatas[0].wastetype = this.selects.wastetypes[0].value;
          }
        });
    },
    getWasteSubType(index) {
      console.log("ada changes");
      this.tableDatas[index].swcode = "";
      // let valuuu = [];
      // reinitialize value sub type
      // this.tableDatas[index].swcode = "";
      // this.selects.wastesubtypes = [];
      // console.log(index);
      // this.selects.wastetypes[index].swcodes = [];

      // for (var i = 0; i < this.selects.wastetypes.length; i++) {
      //   let ttt = [];
      //   console.log(this.selects.wastetypes[i]);
      //   this.$http
      //     .get(
      //       ":10001/api/v1/self/waste-type/" + this.selects.wastetypes[i].value
      //     )
      //     .then((res) => {
      //       if (!res.error) {
      //         let response = res.message;
      //         console.log(response);

      //         for (var j = 0; j < response.length; j++) {
      //           let obj = {
      //             label: response[j].name,
      //             value: response[j].waste_type_sub_id,
      //           };
      //           ttt.push(obj);
      //           // this.selects.wastetypes[index].swcodes.push(obj);
      //           // this.selects.wastesubtypes.push(obj);
      //         }
      //       }
      //     });

      //   this.selects.wastetypes[i].swcodes = ttt;
      // }
      // console.log(this.selects.wastetypes);
    },
    getPackaging() {
      this.selects.packagings = [];
      this.$http.get(":10001/api/v1/reference/packaging").then((res) => {
        if (!res.error) {
          let response = res.message;

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].name,
              value: response[i].packaging_type_id,
            };

            this.selects.packagings.push(obj);
          }

          this.selects.packaging = this.selects.packagings[0].value;
        }
      });
    },
    getDatas() {
      this.$http.get(":10001/api/v1/incoming/" + this.jobno).then((res) => {
        if (!res.error) {
          let response = res.message;
          this.jobreferenceno = response.reference_number;
          // this.previousport =
        }
      });
    },
    getType() {},
    getTypee(index, selectedValue, row) {
      const options = this.selects.wastetypes[index].swcodes;
      this.selectedIndex = options.findIndex(
        (option) => option.value === selectedValue
      );
      console.log("Selected index:", selectedValue);

      if (
        this.selects.wastetypes[index].swcodes[
          this.selectedIndex
        ].label.includes("Other") ||
        this.selects.wastetypes[index].swcodes[
          this.selectedIndex
        ].label.includes("specify")
      ) {
        row.check = true;
      } else {
        row.check = false;
      }
    },
    validate() {
      // if(this.imagebase64 == "" || this.images.regular == null){
      //     swal({
      //         title: "Data Error!",
      //         text: "All data must be filled in.",
      //         type: "warning",
      //         confirmButtonClass: "btn btn-success btn-fill",
      //         buttonsStyling: false,
      //     });
      // } else {
      return this.$validator.validateAll().then((res) => {
        // this.$root.$emit("image", this.imagebase64);
        return res;
      });
      // }
    },
  },
};
</script>
<style scoped>
.new-title {
  margin-top: 20px;
  color: #A5A5A5;
}

.subtitle {
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
  /* height: 20px; */
}

.custom-table .el-table__body td,
.custom-table .el-table__header th {
  /* color: #A5A5A5 !important; */
}

.custom-dropdown-2 {
  width: 300px;
}

.scrollable {
  height: 580px;
  overflow-y: scroll;
  padding-right: 10px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.overlay-content {
  background: transparent;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  z-index: 9999;
}

.link {
  cursor: pointer;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}


</style>
